/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./node_modules/regenerator-runtime/runtime.js":
/*!*****************************************************!*\
  !*** ./node_modules/regenerator-runtime/runtime.js ***!
  \*****************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/* module decorator */ module = __webpack_require__.nmd(module);
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var runtime = function (exports) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;

  var defineProperty = Object.defineProperty || function (obj, key, desc) {
    obj[key] = desc.value;
  };

  var undefined; // More compressible than void 0.

  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }

  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function define(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []); // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.

    defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    });
    return generator;
  }

  exports.wrap = wrap; // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.

  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed"; // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.

  var ContinueSentinel = {}; // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {} // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.


  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));

  if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = GeneratorFunctionPrototype;
  defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: true
  });
  defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: true
  });
  GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"); // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.

  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function (genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
    // do is to check its .name property.
    (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
  };

  exports.mark = function (genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }

    genFun.prototype = Object.create(Gp);
    return genFun;
  }; // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.


  exports.awrap = function (arg) {
    return {
      __await: arg
    };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);

      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;

        if (value && _typeof(value) === "object" && hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function (value) {
            invoke("next", value, resolve, reject);
          }, function (err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function (unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function (error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise = // If enqueue has been called before, then we want to wait until
      // all previous Promises have been resolved before calling invoke,
      // so that results are always delivered in the correct order. If
      // enqueue has not been called before, then it is important to
      // call invoke immediately, without waiting on a callback to fire,
      // so that the async generator function has the opportunity to do
      // any necessary setup in a predictable way. This predictability
      // is why the Promise constructor synchronously invokes its
      // executor callback, and why async functions synchronously
      // execute code before the first await. Since we implement simple
      // async functions in terms of async generators, it is especially
      // important to get this right, even though it requires care.
      previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
      // invocations of the iterator.
      callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    } // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).


    defineProperty(this, "_invoke", {
      value: enqueue
    });
  }

  defineIteratorMethods(AsyncIterator.prototype);
  define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  });
  exports.AsyncIterator = AsyncIterator; // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.

  exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
    : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;
    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        } // Be forgiving, per GeneratorResume behavior specified since ES2015:
        // ES2015 spec, step 3: https://262.ecma-international.org/6.0/#sec-generatorresume
        // Latest spec, step 2: https://tc39.es/ecma262/#sec-generatorresume


        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;

        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);

          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;
        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);
        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;
        var record = tryCatch(innerFn, self, context);

        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done ? GenStateCompleted : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };
        } else if (record.type === "throw") {
          state = GenStateCompleted; // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.

          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  } // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.


  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method;
    var method = delegate.iterator[methodName];

    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method, or a missing .next method, always terminate the
      // yield* loop.
      context.delegate = null; // Note: ["return"] must be used for ES3 parsing compatibility.

      if (methodName === "throw" && delegate.iterator["return"]) {
        // If the delegate iterator has a return method, give it a
        // chance to clean up.
        context.method = "return";
        context.arg = undefined;
        maybeInvokeDelegate(delegate, context);

        if (context.method === "throw") {
          // If maybeInvokeDelegate(context) changed context.method from
          // "return" to "throw", let that override the TypeError below.
          return ContinueSentinel;
        }
      }

      if (methodName !== "return") {
        context.method = "throw";
        context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (!info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value; // Resume execution at the desired location (see delegateYield).

      context.next = delegate.nextLoc; // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.

      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }
    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    } // The delegate iterator is finished, so forget it and continue with
    // the outer generator.


    context.delegate = null;
    return ContinueSentinel;
  } // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.


  defineIteratorMethods(Gp);
  define(Gp, toStringTagSymbol, "Generator"); // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.

  define(Gp, iteratorSymbol, function () {
    return this;
  });
  define(Gp, "toString", function () {
    return "[object Generator]";
  });

  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{
      tryLoc: "root"
    }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function (val) {
    var object = Object(val);
    var keys = [];

    for (var key in object) {
      keys.push(key);
    }

    keys.reverse(); // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.

    return function next() {
      while (keys.length) {
        var key = keys.pop();

        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      } // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.


      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable != null) {
      var iteratorMethod = iterable[iteratorSymbol];

      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1,
            next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;
          return next;
        };

        return next.next = next;
      }
    }

    throw new TypeError(_typeof(iterable) + " is not iterable");
  }

  exports.values = values;

  function doneResult() {
    return {
      value: undefined,
      done: true
    };
  }

  Context.prototype = {
    constructor: Context,
    reset: function reset(skipTempReset) {
      this.prev = 0;
      this.next = 0; // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.

      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;
      this.method = "next";
      this.arg = undefined;
      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },
    stop: function stop() {
      this.done = true;
      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;

      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },
    dispatchException: function dispatchException(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;

      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }
          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }
          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },
    abrupt: function abrupt(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },
    complete: function complete(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" || record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },
    finish: function finish(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },
    "catch": function _catch(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;

          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }

          return thrown;
        }
      } // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.


      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  }; // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.

  return exports;
}( // If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
( false ? 0 : _typeof(module)) === "object" ? module.exports : {});

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, in modern engines
  // we can explicitly access globalThis. In older engines we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  if ((typeof globalThis === "undefined" ? "undefined" : _typeof(globalThis)) === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}

/***/ }),

/***/ "./src/js/modules/blog-filter-bar.js":
/*!*******************************************!*\
  !*** ./src/js/modules/blog-filter-bar.js ***!
  \*******************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var BlogFilterBar = /*#__PURE__*/function (_HTMLElement) {
  _inherits(BlogFilterBar, _HTMLElement);

  var _super = _createSuper(BlogFilterBar);

  function BlogFilterBar() {
    var _this;

    _classCallCheck(this, BlogFilterBar);

    _this = _super.call(this);
    _this._drawer = null;
    _this._desktopBar = null;
    _this._overlay = null;
    _this._dropdowns = [];
    _this._hoverOpenTimer = null;
    _this._leaveCloseTimer = null;
    _this._hoverOpenDelay = 150;
    _this._leaveCloseDelay = 100;
    _this._boundCloseOnOverlayClick = _this._closeOnOverlayClick.bind(_assertThisInitialized(_this));
    _this._boundDocumentClick = _this._onDocumentClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(BlogFilterBar, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._drawer = this.querySelector('#blog-filter-drawer');
      this._desktopBar = this.querySelector('.blog-filter-bar__desktop');
      this._overlay = document.querySelector('.PageOverlay');

      this._attachDrawerListeners();

      this._attachDesktopListeners();

      this._attachOverlayListener();

      this._updateDesktopDropdownBadges();
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      if (this._overlay) {
        this._overlay.removeEventListener('click', this._boundCloseOnOverlayClick);
      }

      document.removeEventListener('click', this._boundDocumentClick, true);
      if (this._hoverOpenTimer) clearTimeout(this._hoverOpenTimer);
      if (this._leaveCloseTimer) clearTimeout(this._leaveCloseTimer);
    }
  }, {
    key: "_blogUrl",
    get: function get() {
      return this.getAttribute('data-blog-url') || '';
    }
  }, {
    key: "_openDrawer",
    value: function _openDrawer() {
      if (!this._drawer) return;

      this._drawer.setAttribute('aria-hidden', 'false');

      document.documentElement.classList.add('no-scroll');
      document.body.classList.add('blog-filter-drawer-open');
      if (this._overlay) this._overlay.classList.add('is-visible');
    }
  }, {
    key: "_closeDrawer",
    value: function _closeDrawer() {
      if (!this._drawer) return;

      this._drawer.setAttribute('aria-hidden', 'true');

      document.documentElement.classList.remove('no-scroll');
      document.body.classList.remove('blog-filter-drawer-open');
      if (this._overlay) this._overlay.classList.remove('is-visible');
    }
  }, {
    key: "_getSelectedHandles",
    value: function _getSelectedHandles(container) {
      if (!container) return [];
      var activeLinks = container.querySelectorAll('.blog-filter-bar__option.is-active .blog-filter-bar__option-link');
      var handles = [];

      for (var i = 0; i < activeLinks.length; i++) {
        var h = activeLinks[i].getAttribute('data-tag-handle');
        if (h) handles.push(h);
      }

      return handles;
    }
  }, {
    key: "_applyFrom",
    value: function _applyFrom(container) {
      var handles = this._getSelectedHandles(container);

      var url = handles.length ? this._blogUrl + '/tagged/' + handles.join('+') : this._blogUrl;
      if (container === this._drawer) this._closeDrawer();
      window.location.href = url;
    }
  }, {
    key: "_toggleOptionInContainer",
    value: function _toggleOptionInContainer(container, optionLink) {
      var handle = optionLink.getAttribute('data-tag-handle');
      var option = optionLink.closest('.blog-filter-bar__option');
      if (!option || !handle || !container) return;
      var isCurrentlyActive = option.classList.contains('is-active');
      var allWithHandle = container.querySelectorAll('.blog-filter-bar__option-link[data-tag-handle="' + handle + '"]');

      for (var i = 0; i < allWithHandle.length; i++) {
        var opt = allWithHandle[i].closest('.blog-filter-bar__option');

        if (opt) {
          if (isCurrentlyActive) opt.classList.remove('is-active');else opt.classList.add('is-active');
        }
      }
    }
  }, {
    key: "_onContainerClick",
    value: function _onContainerClick(container, e) {
      var el = e.target && e.target.nodeType === 1 ? e.target : e.target && e.target.parentElement || null;
      var optionLink = el && el.closest ? el.closest('.blog-filter-bar__option-link') : null;

      if (optionLink) {
        e.preventDefault();
        e.stopPropagation();

        this._toggleOptionInContainer(container, optionLink);

        if (container === this._desktopBar) {
          this._updateDesktopDropdownBadges();
        }
      }
    }
  }, {
    key: "_closeOnOverlayClick",
    value: function _closeOnOverlayClick() {
      if (this._drawer && this._drawer.getAttribute('aria-hidden') === 'false') {
        this._closeDrawer();
      }
    }
  }, {
    key: "_attachDrawerListeners",
    value: function _attachDrawerListeners() {
      var _this2 = this;

      if (!this._drawer) return;
      var openBtn = this.querySelector('[data-action="open-blog-filter-drawer"]');
      if (openBtn) openBtn.addEventListener('click', function () {
        return _this2._openDrawer();
      });
      this.querySelectorAll('[data-action="close-blog-filter-drawer"]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          return _this2._closeDrawer();
        });
      });

      var applyBtn = this._drawer.querySelector('[data-action="apply-blog-filter"]');

      if (applyBtn) {
        applyBtn.addEventListener('click', function (e) {
          e.preventDefault();

          _this2._applyFrom(_this2._drawer);
        });
      }

      this._drawer.addEventListener('click', function (e) {
        return _this2._onContainerClick(_this2._drawer, e);
      }, true);
    }
  }, {
    key: "_closeAllDropdowns",
    value: function _closeAllDropdowns() {
      this._dropdowns.forEach(function (d) {
        if (d.popover.getAttribute('aria-hidden') === 'false') {
          d.popover.setAttribute('aria-hidden', 'true');
          d.trigger.setAttribute('aria-expanded', 'false');
        }
      });

      document.removeEventListener('click', this._boundDocumentClick, true);
    }
  }, {
    key: "_openDropdown",
    value: function _openDropdown(dropdown) {
      this._closeAllDropdowns();

      dropdown.popover.setAttribute('aria-hidden', 'false');
      dropdown.trigger.setAttribute('aria-expanded', 'true');
      document.addEventListener('click', this._boundDocumentClick, true);
    }
  }, {
    key: "_closeDropdown",
    value: function _closeDropdown(dropdown) {
      dropdown.popover.setAttribute('aria-hidden', 'true');
      dropdown.trigger.setAttribute('aria-expanded', 'false');
      var anyOpen = false;

      this._dropdowns.forEach(function (d) {
        if (d.popover.getAttribute('aria-hidden') === 'false') anyOpen = true;
      });

      if (!anyOpen) document.removeEventListener('click', this._boundDocumentClick, true);
    }
  }, {
    key: "_isDropdownOpen",
    value: function _isDropdownOpen(dropdown) {
      return dropdown.popover.getAttribute('aria-hidden') === 'false';
    }
  }, {
    key: "_onDocumentClick",
    value: function _onDocumentClick(e) {
      var target = e.target && e.target.nodeType === 1 ? e.target : null;
      if (!target) return;
      var inTrigger = target.closest('[data-dropdown-trigger]');
      var inPopover = target.closest('.blog-filter-bar__popover');
      if (inTrigger || inPopover) return;

      this._closeAllDropdowns();
    }
  }, {
    key: "_updateDesktopDropdownBadges",
    value: function _updateDesktopDropdownBadges() {
      if (!this._desktopBar) return;

      this._dropdowns.forEach(function (d) {
        var activeCount = d.popover.querySelectorAll('.blog-filter-bar__option.is-active').length;
        var badge = d.trigger.querySelector('.blog-filter-bar__dropdown-badge');

        if (badge) {
          if (activeCount > 0) {
            badge.textContent = String(activeCount);
            badge.removeAttribute('hidden');
          } else {
            badge.textContent = '';
            badge.setAttribute('hidden', '');
          }
        }

        if (activeCount > 0) {
          d.trigger.classList.add('is-active');
        } else {
          d.trigger.classList.remove('is-active');
        }
      });
    }
  }, {
    key: "_attachDesktopListeners",
    value: function _attachDesktopListeners() {
      var _this3 = this;

      if (!this._desktopBar) return;

      var dropdownEls = this._desktopBar.querySelectorAll('.blog-filter-bar__dropdown');

      dropdownEls.forEach(function (wrap) {
        var groupKey = wrap.getAttribute('data-filter-group');
        var trigger = wrap.querySelector('[data-dropdown-trigger]');
        var popover = wrap.querySelector('[data-dropdown-popover][data-filter-group="' + groupKey + '"]');
        if (!trigger || !popover) return;

        _this3._dropdowns.push({
          trigger: trigger,
          popover: popover
        });

        trigger.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();

          if (_this3._isDropdownOpen({
            trigger: trigger,
            popover: popover
          })) {
            _this3._closeDropdown({
              trigger: trigger,
              popover: popover
            });
          } else {
            _this3._openDropdown({
              trigger: trigger,
              popover: popover
            });
          }
        });
        trigger.addEventListener('mouseenter', function () {
          if (_this3._hoverOpenTimer) clearTimeout(_this3._hoverOpenTimer);
          _this3._hoverOpenTimer = setTimeout(function () {
            _this3._hoverOpenTimer = null;

            _this3._openDropdown({
              trigger: trigger,
              popover: popover
            });
          }, _this3._hoverOpenDelay);
        });
        trigger.addEventListener('mouseleave', function () {
          if (_this3._hoverOpenTimer) {
            clearTimeout(_this3._hoverOpenTimer);
            _this3._hoverOpenTimer = null;
          }

          if (_this3._leaveCloseTimer) clearTimeout(_this3._leaveCloseTimer);
          var d = {
            trigger: trigger,
            popover: popover
          };
          _this3._leaveCloseTimer = setTimeout(function () {
            _this3._leaveCloseTimer = null;
            if (_this3._isDropdownOpen(d)) _this3._closeDropdown(d);
          }, _this3._leaveCloseDelay);
        });
        popover.addEventListener('mouseenter', function () {
          if (_this3._leaveCloseTimer) {
            clearTimeout(_this3._leaveCloseTimer);
            _this3._leaveCloseTimer = null;
          }
        });
        popover.addEventListener('mouseleave', function () {
          if (_this3._leaveCloseTimer) clearTimeout(_this3._leaveCloseTimer);
          var d = {
            trigger: trigger,
            popover: popover
          };
          _this3._leaveCloseTimer = setTimeout(function () {
            _this3._leaveCloseTimer = null;
            if (_this3._isDropdownOpen(d)) _this3._closeDropdown(d);
          }, _this3._leaveCloseDelay);
        });
      });

      this._desktopBar.addEventListener('click', function (e) {
        return _this3._onContainerClick(_this3._desktopBar, e);
      }, true);

      var desktopApplyBtn = this._desktopBar.querySelector('[data-action="apply-blog-filter-desktop"]');

      if (desktopApplyBtn) {
        desktopApplyBtn.addEventListener('click', function (e) {
          e.preventDefault();

          _this3._applyFrom(_this3._desktopBar);
        });
      }
    }
  }, {
    key: "_attachOverlayListener",
    value: function _attachOverlayListener() {
      if (this._overlay && this._drawer) {
        this._overlay.addEventListener('click', this._boundCloseOnOverlayClick);
      }
    }
  }]);

  return BlogFilterBar;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

customElements.define('blog-filter-bar', BlogFilterBar);

/***/ }),

/***/ "./src/js/modules/ed-auto-discount.js":
/*!********************************************!*\
  !*** ./src/js/modules/ed-auto-discount.js ***!
  \********************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var EdApplyDiscount = /*#__PURE__*/function (_HTMLElement) {
  _inherits(EdApplyDiscount, _HTMLElement);

  var _super = _createSuper(EdApplyDiscount);

  function EdApplyDiscount() {
    _classCallCheck(this, EdApplyDiscount);

    return _super.apply(this, arguments);
  }

  _createClass(EdApplyDiscount, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.discountCode = this.dataset.discountCode || 'elbDev-TR';
      this.applyDiscount();
    }
  }, {
    key: "applyDiscount",
    value: function applyDiscount() {
      var _this = this;

      fetch("/discount/".concat(encodeURIComponent(this.discountCode)), {
        method: 'GET'
      }).then(function (response) {
        if (response.ok) {
          console.log("Discount code \"".concat(_this.discountCode, "\" applied successfully"));
        } else {
          console.log("Failed to apply discount code \"".concat(_this.discountCode, "\": ").concat(response.status));
        }
      })["catch"](function (error) {
        console.log("Error applying discount code \"".concat(_this.discountCode, "\":"), error);
      });
    }
  }]);

  return EdApplyDiscount;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

customElements.define('ed-auto-discount', EdApplyDiscount);
document.querySelectorAll('ed-auto-discount').forEach(function (el) {
  if (!el.discountCode) {
    el.connectedCallback();
  }
});

/***/ }),

/***/ "./src/js/modules/ed-bundles.js":
/*!**************************************!*\
  !*** ./src/js/modules/ed-bundles.js ***!
  \**************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var EdBundles = /*#__PURE__*/function (_HTMLElement) {
  _inherits(EdBundles, _HTMLElement);

  var _super = _createSuper(EdBundles);

  function EdBundles() {
    _classCallCheck(this, EdBundles);

    return _super.apply(this, arguments);
  }

  _createClass(EdBundles, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();

      this._attachListeners();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.buttons = this.querySelectorAll('.ed-bundles__card');
      this.form = document.querySelector('form.product-single__form');
      this.variantSelect = document.querySelector('select.product-single__variants');
      this.addToCartButton = document.querySelector('[data-add-to-cart]');
      this.addToCartText = document.querySelector('[data-add-to-cart-text]');
      this.notifyButton = document.querySelector('.btnnotify');
      this.availableEta = document.querySelector('.ed-shipping-eta.available');
      this.soldOutEta = document.querySelector('.shipping-eta.soldout');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      var _this = this;

      this.buttons.forEach(function (button) {
        button.addEventListener('click', function (e) {
          return _this._handleClick(e);
        });
      });
    }
  }, {
    key: "_handleClick",
    value: function _handleClick(e) {
      this.buttons.forEach(function (btn) {
        return btn.classList.remove('ed-bundles__card--active');
      });
      e.currentTarget.classList.add('ed-bundles__card--active');
      var variantSelect = this.variantSelect;

      if (variantSelect) {
        var productId = e.currentTarget.getAttribute('data-product-id');
        var variantId = e.currentTarget.getAttribute('data-variant-id');
        var rawDeliveryLabel = e.currentTarget.getAttribute('data-delivery-label');
        var deliveryLabel = rawDeliveryLabel && rawDeliveryLabel !== 'undefined' ? rawDeliveryLabel : '';

        if (productId && variantId) {
          variantSelect.setAttribute('data-productid', productId);
          var variantScript = this.querySelector("script[data-variant=\"".concat(variantId, "\"]"));

          if (variantScript) {
            var variant = JSON.parse(variantScript.textContent);
            var targetOption = variantSelect.querySelector("option[value=\"".concat(variantId, "\"]"));

            if (!targetOption) {
              targetOption = document.createElement('option');
              targetOption.value = variantId;
              targetOption.textContent = (variant === null || variant === void 0 ? void 0 : variant.name) || 'Default Title';
              variantSelect.appendChild(targetOption);
            }

            variantSelect.querySelectorAll('option').forEach(function (option) {
              return option.removeAttribute('selected');
            });
            targetOption.setAttribute('selected', 'selected');
            variantSelect.value = variantId;

            this._syncProductFormInputs(productId, variantId);

            this._syncAtcUiState(variant, deliveryLabel);

            document.dispatchEvent(new CustomEvent('variant:change', {
              detail: {
                variant: variant,
                deliveryLabel: deliveryLabel
              },
              bubbles: true
            }));
            var event = new CustomEvent('bundleChange', {
              detail: {
                variant: variant
              },
              bubbles: true
            });
            document.dispatchEvent(event);
            var productTitle = document.querySelector('.product-single__title');

            if (productTitle && variant.name) {
              productTitle.textContent = variant.name;
            }
          }
        } else {
          this._syncProductFormInputs(productId || '', '');

          this._syncAtcUiState({
            id: null,
            available: false
          }, deliveryLabel);
        }
      }
    }
  }, {
    key: "_syncProductFormInputs",
    value: function _syncProductFormInputs(productId, variantId) {
      if (this.form) {
        this.form.setAttribute('data-productid', productId);
        var productIdInput = this.form.querySelector('input[name="product-id"]');

        if (productIdInput) {
          productIdInput.value = productId;
        }

        var hiddenVariantInput = this.form.querySelector('input[data-ed-bundle-variant-id]');

        if (!hiddenVariantInput) {
          hiddenVariantInput = document.createElement('input');
          hiddenVariantInput.type = 'hidden';
          hiddenVariantInput.name = 'id';
          hiddenVariantInput.setAttribute('data-ed-bundle-variant-id', 'true');
          this.form.appendChild(hiddenVariantInput);
        }

        hiddenVariantInput.value = variantId;
      }
    }
  }, {
    key: "_syncAtcUiState",
    value: function _syncAtcUiState(variant) {
      var deliveryLabel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

      if (!this.addToCartButton || !this.addToCartText) {
        return;
      }

      var isAvailable = Boolean(variant === null || variant === void 0 ? void 0 : variant.available);

      if (isAvailable) {
        this.addToCartButton.disabled = false;
        this.addToCartButton.classList.remove('disabled');
        this.addToCartText.textContent = this.addToCartText.dataset.defaultText || 'In den Warenkorb';

        if (this.availableEta && deliveryLabel) {
          this.availableEta.textContent = deliveryLabel;
        }

        if (this.notifyButton) this.notifyButton.style.display = 'none';
        if (this.availableEta) this.availableEta.style.display = '';
        if (this.soldOutEta) this.soldOutEta.style.display = 'none';
      } else {
        this.addToCartButton.disabled = true;
        this.addToCartButton.classList.add('disabled');
        this.addToCartText.textContent = this.addToCartText.dataset.soldOutText || 'Ausverkauft';
        if (this.notifyButton) this.notifyButton.style.display = 'block';
        if (this.availableEta) this.availableEta.style.display = 'none';
        if (this.soldOutEta) this.soldOutEta.style.display = '';
      }
    }
  }]);

  return EdBundles;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

if (!customElements.get('ed-bundles')) {
  customElements.define('ed-bundles', EdBundles);
}

/***/ }),

/***/ "./src/js/modules/ed-cart-qty-ajax.js":
/*!********************************************!*\
  !*** ./src/js/modules/ed-cart-qty-ajax.js ***!
  \********************************************/
/***/ (() => {

var SELECTOR = {
  adjust: '.ed-js-qty__adjust',
  plus: '.ed-js-qty__adjust--plus',
  wrapper: '.js-qty__wrapper',
  input: '.js-qty__num'
};
var CART_FORM_ID = 'CartPageForm';
var LOADING_CLASS = 'is-loading';

function getCartPageForm() {
  return document.getElementById(CART_FORM_ID);
}

function isDisabledAdjust(btn) {
  return btn.classList.contains('ed-qty--at-limit') || btn.getAttribute('aria-disabled') === 'true';
}

function clampQty(input, qty) {
  var min = parseInt(input.getAttribute('min'), 10);
  var minValue = Number.isFinite(min) ? min : 1;
  if (qty < minValue) qty = minValue;
  var max = parseInt(input.getAttribute('max'), 10);
  if (Number.isFinite(max) && qty > max) qty = max;
  return qty;
}

function removeLine(key, wrapper, fallbackHref) {
  var themeCart = window.theme && window.theme.cart;

  if (!themeCart || typeof themeCart.changeItem !== 'function') {
    window.location.href = fallbackHref || "/cart/change?id=".concat(encodeURIComponent(key), "&quantity=0");
    return;
  }

  wrapper.classList.add(LOADING_CLASS);
  themeCart.changeItem(key, 0).then(function (cart) {
    document.dispatchEvent(new CustomEvent('cart:build', {
      bubbles: true
    }));
    document.dispatchEvent(new CustomEvent('cart:updated', {
      detail: {
        cart: cart
      }
    }));
  })["catch"](function () {
    wrapper.classList.remove(LOADING_CLASS);
  });
}

function applyQty(input, wrapper, qty, fallbackHref) {
  input.value = qty;

  if (qty === 0) {
    removeLine(input.dataset.id, wrapper, fallbackHref);
    return;
  }

  document.dispatchEvent(new CustomEvent('cart:quantity.cart-page', {
    detail: [input.dataset.id, qty, wrapper]
  }));
}

function onQtyClick(event) {
  var btn = event.target.closest(SELECTOR.adjust);
  if (!btn) return;
  var form = getCartPageForm();
  if (!form || !form.contains(btn)) return;
  event.preventDefault();
  event.stopPropagation();
  if (isDisabledAdjust(btn)) return;
  var wrapper = btn.closest(SELECTOR.wrapper);
  var input = wrapper && wrapper.querySelector(SELECTOR.input);
  if (!wrapper || !input || !input.dataset.id) return;
  if (wrapper.classList.contains(LOADING_CLASS)) return;
  var qty = parseInt(input.value, 10);
  if (!Number.isFinite(qty)) qty = 1;
  qty += btn.matches(SELECTOR.plus) ? 1 : -1;
  applyQty(input, wrapper, clampQty(input, qty), btn.getAttribute('href'));
}

function onQtyInputChange(event) {
  var input = event.target;
  if (!input.matches || !input.matches(SELECTOR.input)) return;
  var form = getCartPageForm();
  if (!form || !form.contains(input)) return;
  event.stopPropagation();
  var wrapper = input.closest(SELECTOR.wrapper);
  if (!wrapper || !input.dataset.id) return;
  if (wrapper.classList.contains(LOADING_CLASS)) return;
  var qty = parseInt(input.value, 10);
  if (!Number.isFinite(qty)) qty = 1;
  applyQty(input, wrapper, clampQty(input, qty));
}

document.addEventListener('click', onQtyClick, true);
document.addEventListener('change', onQtyInputChange, true);

/***/ }),

/***/ "./src/js/modules/ed-cart-refresh.js":
/*!*******************************************!*\
  !*** ./src/js/modules/ed-cart-refresh.js ***!
  \*******************************************/
/***/ (() => {

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var REGION_SELECTOR = '[data-ed-cart-refresh]';
var CART_FORM_ID = 'CartPageForm';
var DEBOUNCE_MS = 150;
var debounceTimer = null;
var requestSeq = 0;

function getSectionId() {
  var region = document.querySelector(REGION_SELECTOR);
  var sectionEl = region && region.closest('.shopify-section');
  if (!sectionEl || !sectionEl.id) return null;
  return sectionEl.id.replace(/^shopify-section-/, '');
}

function refreshRegions() {
  return _refreshRegions.apply(this, arguments);
}

function _refreshRegions() {
  _refreshRegions = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var sectionId, seq, html, response, doc;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            sectionId = getSectionId();

            if (sectionId) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return");

          case 3:
            seq = ++requestSeq;
            _context.prev = 4;
            _context.next = 7;
            return fetch("".concat(window.location.pathname, "?section_id=").concat(encodeURIComponent(sectionId)), {
              credentials: 'same-origin'
            });

          case 7:
            response = _context.sent;

            if (response.ok) {
              _context.next = 10;
              break;
            }

            return _context.abrupt("return");

          case 10:
            _context.next = 12;
            return response.text();

          case 12:
            html = _context.sent;
            _context.next = 18;
            break;

          case 15:
            _context.prev = 15;
            _context.t0 = _context["catch"](4);
            return _context.abrupt("return");

          case 18:
            if (!(seq !== requestSeq)) {
              _context.next = 20;
              break;
            }

            return _context.abrupt("return");

          case 20:
            doc = new DOMParser().parseFromString(html, 'text/html');
            document.querySelectorAll(REGION_SELECTOR).forEach(function (live) {
              var key = live.getAttribute('data-ed-cart-refresh');
              var fresh = doc.querySelector("[data-ed-cart-refresh=\"".concat(CSS.escape(key), "\"]"));
              if (fresh) live.replaceWith(fresh);
            });

          case 22:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[4, 15]]);
  }));
  return _refreshRegions.apply(this, arguments);
}

function scheduleRefresh() {
  if (!document.getElementById(CART_FORM_ID)) return;
  if (debounceTimer) window.clearTimeout(debounceTimer);
  debounceTimer = window.setTimeout(function () {
    debounceTimer = null;
    refreshRegions();
  }, DEBOUNCE_MS);
}

document.addEventListener('cart:updated', scheduleRefresh);
document.addEventListener('cart:build', scheduleRefresh);

/***/ }),

/***/ "./src/js/modules/ed-cart-upsell.js":
/*!******************************************!*\
  !*** ./src/js/modules/ed-cart-upsell.js ***!
  \******************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var EdCartUpsell = /*#__PURE__*/function (_HTMLElement) {
  _inherits(EdCartUpsell, _HTMLElement);

  var _super = _createSuper(EdCartUpsell);

  function EdCartUpsell() {
    _classCallCheck(this, EdCartUpsell);

    return _super.apply(this, arguments);
  }

  _createClass(EdCartUpsell, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();

      this._attachListeners();

      this._updateUpsell();

      console.log('EdCartUpsell initiated');
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.wrapperEl = this.querySelector('.ed-cart-upsell-wrapper');
      this.imageEl = this.querySelector('.upsell-product-image');
      this.titleEl = this.querySelector('.upsell-product-title');
      this.priceEl = this.querySelector('.upsell-product-price');
      this.unitPriceEl = this.querySelector('.upsell-product-unit-price');
      this.variantWrapperEl = this.querySelector('.upsell-variant-wrapper');
      this.variantSelectEl = this.querySelector('.upsell-variant-select');
      this.addButtonEl = this.querySelector('.upsell-add-button');
      this.badgeEl = this.querySelector('.upsell-frame-badge');
      this.imageWrapperEl = this.querySelector('.upsell-product-image__wrapper');
      this.infoTriggerEl = this.querySelector('.upsell-badge-info__trigger');
      this.infoModalEl = this.querySelector('.upsell-product-badge-info__modal');
      this.infoModalBodyEl = this.querySelector('.upsell-badge-info__modal-body');
      this.infoModalCloseEl = this.querySelector('.upsell-badge-info__close');
      this.scriptEl = this.querySelector('script[data-cart]');
      this.cart = JSON.parse(this.scriptEl.textContent).cart;
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      var _this = this;

      if (this.variantSelectEl) {
        this.variantSelectEl.addEventListener('change', this._onVariantChange.bind(this));
      }

      if (this.addButtonEl) {
        this.addButtonEl.addEventListener('click', function (event) {
          event.preventDefault();

          _this._onAddToCart();
        });
      }

      if (this.infoTriggerEl) {
        this.infoTriggerEl.addEventListener('click', this._openInfoModal.bind(this));
      }

      if (this.infoModalCloseEl) {
        this.infoModalCloseEl.addEventListener('click', this._closeInfoModal.bind(this));
      }

      if (this.infoModalEl) {
        this.infoModalEl.addEventListener('click', function (e) {
          if (e.target === _this.infoModalEl) _this._closeInfoModal();
        });
      }

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') _this._closeInfoModal();
      });
      document.addEventListener('cart:updated', this._onExternalCartUpdated.bind(this));
    }
  }, {
    key: "_onExternalCartUpdated",
    value: function _onExternalCartUpdated(event) {
      if (this._ownCartUpdate) return;
      var cart = event && event.detail && event.detail.cart;
      if (!cart || !Array.isArray(cart.items)) return;
      this.cart = cart;

      if (this.scriptEl) {
        this.scriptEl.textContent = JSON.stringify({
          cart: cart
        });
      }

      this._updateUpsell();
    }
  }, {
    key: "_updateUpsell",
    value: function _updateUpsell() {
      var _this2 = this;

      try {
        var cart = this.cart;

        if (!cart || !cart.items || cart.items.length === 0) {
          this.wrapperEl.style.display = 'none';
          return;
        }

        var upsellItemCount = cart.items.filter(function (item) {
          return item.properties && item.properties._upsellItem === 'true';
        }).length;

        if (upsellItemCount >= 3) {
          this.wrapperEl.style.display = 'none';
          return;
        }

        if (this.addButtonEl) this.addButtonEl.disabled = true;
        var firstCartItem = cart.items[cart.items.length - 1];
        var firstProductId = firstCartItem.product_id || firstCartItem.id;

        this._fetchRecommendations(firstProductId).then(function (recommendedProducts) {
          // Filter out any recommended products already in the cart
          var cartProductIds = cart.items.map(function (item) {
            return item.product_id || item.id;
          });
          var firstAvailableProduct = recommendedProducts.find(function (p) {
            return !cartProductIds.includes(p.id);
          });

          if (!firstAvailableProduct) {
            _this2.wrapperEl.style.display = 'none';
            return null;
          }

          _this2._currentRecommendedProduct = firstAvailableProduct;
          return _this2._populateUpsell();
        }).then(function () {
          if (_this2._currentRecommendedProduct) {
            _this2.wrapperEl.style.display = 'block';
          }
        })["catch"](function (e) {
          console.error('Error updating upsell:', e);
          _this2.wrapperEl.style.display = 'none';
        });
      } catch (e) {
        console.error('Error updating upsell:', e);
        this.wrapperEl.style.display = 'none';
      }
    }
  }, {
    key: "_populateUpsell",
    value: function _populateUpsell() {
      var _this3 = this;

      var product = this._currentRecommendedProduct;

      if (!product) {
        return Promise.resolve();
      }

      this.imageEl.src = product.featured_image;
      this.imageEl.alt = product.title;
      this.titleEl.textContent = product.title;
      this.titleEl.href = product.url;
      this.priceEl.textContent = theme.Currency.formatMoney(product.price, theme.settings.moneyFormat); // fetch full product data for variants/unit price

      return this._fetchProductData(product.handle).then(function (productData) {
        _this3.productData = productData;
        var variants = productData.variants || []; // For subscription-only products, grab the first selling plan so we can pass it on add

        var isSubscriptionOnly = variants.length > 0 && variants.every(function (v) {
          return v.requires_selling_plan;
        });

        if (isSubscriptionOnly) {
          var _productData$selling_, _productData$selling_2, _productData$selling_3;

          var firstPlan = (_productData$selling_ = productData.selling_plan_groups) === null || _productData$selling_ === void 0 ? void 0 : (_productData$selling_2 = _productData$selling_[0]) === null || _productData$selling_2 === void 0 ? void 0 : (_productData$selling_3 = _productData$selling_2.selling_plans) === null || _productData$selling_3 === void 0 ? void 0 : _productData$selling_3[0];
          _this3._sellingPlanId = firstPlan ? firstPlan.id : null;
          console.log('EdCartUpsell: subscription product, selling_plan_id =', _this3._sellingPlanId);
        } else {
          _this3._sellingPlanId = null;
        }

        if (variants.length > 1) {
          _this3.variantWrapperEl.style.display = 'block';
          _this3.variantSelectEl.innerHTML = '';
          var firstAvailableVariantId = null;
          variants.forEach(function (variant) {
            var opt = document.createElement('option');
            opt.value = variant.id;
            opt.textContent = "".concat(variant.title, " - ").concat(theme.Currency.formatMoney(variant.price, theme.settings.moneyFormat));

            if (!variant.available) {
              opt.disabled = true;
            } else if (firstAvailableVariantId === null) {
              firstAvailableVariantId = variant.id;
            }

            _this3.variantSelectEl.appendChild(opt);
          });

          if (firstAvailableVariantId) {
            _this3.variantSelectEl.value = firstAvailableVariantId;
            _this3._selectedVariantId = firstAvailableVariantId;
          } else {
            _this3._selectedVariantId = _this3.variantSelectEl.options[0].value;
          }
        } else {
          _this3.variantWrapperEl.style.display = 'none';

          if (variants.length === 1) {
            // Single variant
            if (!variants[0].available) {
              _this3.addButtonEl.disabled = true;
            }

            _this3._selectedVariantId = variants[0].id;
          } else {
            // Edge case: no variant array, use product ID
            _this3._selectedVariantId = product.id;
          }
        }

        _this3._updateUnitPriceDisplay();

        _this3._renderBadge(productData);

        _this3._fetchMetaInfo(product.handle);

        if (_this3.addButtonEl) _this3.addButtonEl.disabled = false;
      });
    }
  }, {
    key: "_renderBadge",
    value: function _renderBadge(productData) {
      if (!this.badgeEl) return;
      var compareAtPrice = productData.compare_at_price;
      var price = productData.price;

      if (compareAtPrice && compareAtPrice > price) {
        var _this$imageWrapperEl;

        var percentage = Math.round((compareAtPrice - price) * 100 / compareAtPrice);
        var spanEl = this.badgeEl.querySelector('.frame-title span');
        if (spanEl) spanEl.textContent = "-".concat(percentage, "%");
        this.badgeEl.style.display = '';
        (_this$imageWrapperEl = this.imageWrapperEl) === null || _this$imageWrapperEl === void 0 ? void 0 : _this$imageWrapperEl.classList.add('pt-2');
      } else {
        var _this$imageWrapperEl2;

        this.badgeEl.style.display = 'none !important';
        (_this$imageWrapperEl2 = this.imageWrapperEl) === null || _this$imageWrapperEl2 === void 0 ? void 0 : _this$imageWrapperEl2.classList.remove('pt-2');
      }
    }
  }, {
    key: "_fetchMetaInfo",
    value: function _fetchMetaInfo(handle) {
      var _this4 = this;

      if (!this.infoTriggerEl || !this.infoModalBodyEl) return;
      fetch("/products/".concat(handle, "?view=ed-upsell-meta")).then(function (response) {
        return response.text();
      }).then(function (text) {
        var value = text.trim();

        if (value) {
          _this4.infoModalBodyEl.innerHTML = value;
          _this4.infoTriggerEl.style.display = '';
        } else {
          _this4.infoTriggerEl.style.display = 'none';
        }
      })["catch"](function () {
        _this4.infoTriggerEl.style.display = 'none';
      });
    }
  }, {
    key: "_openInfoModal",
    value: function _openInfoModal() {
      var _this$infoModalCloseE;

      if (!this.infoModalEl) return;
      this.infoModalEl.removeAttribute('hidden');
      this.infoModalEl.classList.add('is-open');
      this.infoTriggerEl.setAttribute('aria-expanded', 'true');
      (_this$infoModalCloseE = this.infoModalCloseEl) === null || _this$infoModalCloseE === void 0 ? void 0 : _this$infoModalCloseE.focus();
    }
  }, {
    key: "_closeInfoModal",
    value: function _closeInfoModal() {
      if (!this.infoModalEl || !this.infoModalEl.classList.contains('is-open')) return;
      this.infoModalEl.classList.remove('is-open');
      this.infoModalEl.setAttribute('hidden', '');
      this.infoTriggerEl.setAttribute('aria-expanded', 'false');
      this.infoTriggerEl.focus();
    }
  }, {
    key: "_onVariantChange",
    value: function _onVariantChange(event) {
      this._selectedVariantId = event.target.value;

      this._updateVariantInfo();
    }
  }, {
    key: "_updateVariantInfo",
    value: function _updateVariantInfo() {
      var _this5 = this;

      if (!this._selectedVariantId || !this.productData) return;
      var variant = this.productData.variants.find(function (v) {
        return v.id == _this5._selectedVariantId;
      });
      if (!variant) return; // Update the main price element with the selected variant's price

      this.priceEl.textContent = theme.Currency.formatMoney(variant.price, theme.settings.moneyFormat);

      this._updateUnitPriceDisplay();
    }
  }, {
    key: "_updateUnitPriceDisplay",
    value: function _updateUnitPriceDisplay() {
      var _this6 = this;

      if (!this._selectedVariantId || !this.productData) {
        this.unitPriceEl.style.display = 'none';
        return;
      }

      var variant = this.productData.variants.find(function (v) {
        return v.id == _this6._selectedVariantId;
      });

      if (!variant) {
        this.unitPriceEl.style.display = 'none';
        return;
      }

      if (variant.unit_price && variant.unit_price_measurement) {
        var unitPrice = theme.Currency.formatMoney(variant.unit_price, theme.settings.moneyFormat);
        var measurement = variant.unit_price_measurement;
        this.unitPriceEl.textContent = "".concat(unitPrice, "/").concat(measurement.reference_value).concat(measurement.reference_unit);
        this.unitPriceEl.style.display = 'block';
      } else {
        this.unitPriceEl.style.display = 'none';
      }
    }
  }, {
    key: "_getCartJsonUrl",
    value: function _getCartJsonUrl() {
      var cartUrl = window.theme && window.theme.routes && window.theme.routes.cart || '/cart.js';
      return "".concat(cartUrl).concat(cartUrl.includes('?') ? '&' : '?', "t=").concat(Date.now());
    }
  }, {
    key: "_applyCartToPage",
    value: function _applyCartToPage(cart) {
      this.cart = cart;

      if (this.scriptEl) {
        this.scriptEl.textContent = JSON.stringify({
          cart: cart
        });
      }

      this._ownCartUpdate = true;

      try {
        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: {
            cart: cart
          }
        }));
      } finally {
        this._ownCartUpdate = false;
      }

      document.dispatchEvent(new CustomEvent('cart:build', {
        bubbles: true
      }));
    }
  }, {
    key: "_refreshCartAfterAdd",
    value: function _refreshCartAfterAdd() {
      var _this7 = this;

      return fetch(this._getCartJsonUrl(), {
        credentials: 'same-origin'
      }).then(function (response) {
        if (!response.ok) {
          throw new Error("cart.js failed (".concat(response.status, ")"));
        }

        return response.json();
      }).then(function (cart) {
        _this7._applyCartToPage(cart);

        _this7._updateUpsell();

        return cart;
      });
    }
  }, {
    key: "_onAddToCart",
    value: function _onAddToCart() {
      var _this8 = this;

      if (!this._selectedVariantId || !this.addButtonEl) return;
      var variantId = this._selectedVariantId;
      var previousLabel = this.addButtonEl.textContent;
      this.addButtonEl.disabled = true;
      this.addButtonEl.classList.add('btn--loading');

      this._addToCart(variantId, 1, {
        _upsellItem: 'true'
      }, this._sellingPlanId).then(function () {
        return _this8._refreshCartAfterAdd();
      })["catch"](function (e) {
        console.error('Error adding upsell to cart:', e);
      })["finally"](function () {
        if (!_this8.addButtonEl) return;
        _this8.addButtonEl.disabled = false;

        _this8.addButtonEl.classList.remove('btn--loading');

        _this8.addButtonEl.textContent = previousLabel;
      });
    }
  }, {
    key: "_fetchRecommendations",
    value: function _fetchRecommendations(productId) {
      var url = "".concat(window.Shopify.routes.root, "recommendations/products.json?product_id=").concat(productId, "&intent=related");
      return fetch(url).then(function (response) {
        if (!response.ok) {
          throw new Error('Failed to fetch recommendations');
        }

        return response.json();
      }).then(function (data) {
        return data.products || [];
      });
    }
  }, {
    key: "_fetchProductData",
    value: function _fetchProductData(handle) {
      return fetch("/products/".concat(handle, ".js")).then(function (response) {
        if (!response.ok) {
          throw new Error('Failed to fetch product data');
        }

        return response.json();
      });
    }
  }, {
    key: "_addToCart",
    value: function _addToCart(id, quantity) {
      var properties = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var sellingPlanId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var payload = {
        id: id,
        quantity: quantity,
        properties: properties
      };
      if (sellingPlanId) payload.selling_plan = sellingPlanId;
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      }).then(function (response) {
        if (!response.ok) {
          return response.json()["catch"](function () {
            return response.text()["catch"](function () {
              return '(unreadable)';
            });
          }).then(function (errorBody) {
            console.error('Cart add failed:', response.status, errorBody);
            throw new Error("Failed to add to cart: ".concat(response.status, " - ").concat(JSON.stringify(errorBody)));
          });
        }

        return response.json();
      });
    }
  }]);

  return EdCartUpsell;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

customElements.define('ed-cart-upsell', EdCartUpsell);

/***/ }),

/***/ "./src/js/modules/ed-featured-product.js":
/*!***********************************************!*\
  !*** ./src/js/modules/ed-featured-product.js ***!
  \***********************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var EdFeaturedProduct = /*#__PURE__*/function (_HTMLElement) {
  _inherits(EdFeaturedProduct, _HTMLElement);

  var _super = _createSuper(EdFeaturedProduct);

  function EdFeaturedProduct() {
    _classCallCheck(this, EdFeaturedProduct);

    return _super.apply(this, arguments);
  }

  _createClass(EdFeaturedProduct, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();

      this._attachListeners();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.variantSelect = this.querySelector('#ed-variant-select');
      this.addToCartButton = this.querySelector('.ed-add-to-cart');
      this.priceElement = this.querySelector('[data-featured-product-price]');
      this.comparePriceElement = this.querySelector('.ed-featured-product__compare-price'); // Parse product data

      var productDataScript = this.querySelector('script[type="application/json"].product-data');

      if (productDataScript) {
        this.productData = JSON.parse(productDataScript.innerHTML);
      } // Parse shop data


      var shopDataScript = this.querySelector('script[type="application/json"].shop-data');

      if (shopDataScript) {
        this.shopData = JSON.parse(shopDataScript.innerHTML);
      } // Set initial variant ID on the Add to Cart button


      if (this.variantSelect) {
        this.addToCartButton.setAttribute('data-variant-id', this.variantSelect.value);
      } else {
        this.addToCartButton.setAttribute('data-variant-id', this.querySelector('#ed-variant-select').value);
      }
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      var _this = this;

      if (this.variantSelect) {
        this.variantSelect.addEventListener('change', function (event) {
          _this._onVariantChange(event);
        });
      }

      if (this.addToCartButton) {
        this.addToCartButton.addEventListener('click', function (event) {
          _this._onAddToCart(event);
        });
      }
    }
  }, {
    key: "_onVariantChange",
    value: function _onVariantChange(event) {
      var selectedVariantId = event.target.value;

      if (this.productData) {
        var selectedVariant = this.productData.variants.find(function (variant) {
          return variant.id == selectedVariantId;
        });

        if (selectedVariant) {
          // Update price
          this.priceElement.innerText = this._formatMoney(selectedVariant.price); // Update compare at price

          if (selectedVariant.compare_at_price && selectedVariant.compare_at_price > selectedVariant.price) {
            this.comparePriceElement.innerHTML = '<s>' + this._formatMoney(selectedVariant.compare_at_price) + '</s>';
            this.comparePriceElement.style.display = 'block';
          } else {
            this.comparePriceElement.style.display = 'none';
          } // Update Add to Cart button data attribute


          this.addToCartButton.setAttribute('data-variant-id', selectedVariantId);
        }
      }
    }
  }, {
    key: "_onAddToCart",
    value: function _onAddToCart(event) {
      var selectedVariantId = this.addToCartButton.getAttribute('data-variant-id');

      if (selectedVariantId) {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            items: [{
              id: parseInt(selectedVariantId, 10),
              quantity: 1
            }]
          })
        }).then(function (response) {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }

          return response.json();
        }).then(function (data) {
          window.location.href = '/cart';
        })["catch"](function (error) {
          console.error('Error adding item to cart:', error);
        });
      }
    }
  }, {
    key: "_formatMoney",
    value: function _formatMoney(cents) {
      var currency = this.shopData && this.shopData.currency ? this.shopData.currency : 'EUR';
      return (cents / 100).toLocaleString(undefined, {
        style: 'currency',
        currency: currency
      });
    }
  }]);

  return EdFeaturedProduct;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

customElements.define('ed-featured-product', EdFeaturedProduct);

/***/ }),

/***/ "./src/js/modules/ed-known-for.js":
/*!****************************************!*\
  !*** ./src/js/modules/ed-known-for.js ***!
  \****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _glidejs_glide__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @glidejs/glide */ "./node_modules/@glidejs/glide/dist/glide.esm.js");
/* harmony import */ var _glidejs_glide_dist_css_glide_core_min_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @glidejs/glide/dist/css/glide.core.min.css */ "./node_modules/@glidejs/glide/dist/css/glide.core.min.css");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }




var EdKnownForSlider = /*#__PURE__*/function (_HTMLElement) {
  _inherits(EdKnownForSlider, _HTMLElement);

  var _super = _createSuper(EdKnownForSlider);

  function EdKnownForSlider() {
    var _this;

    _classCallCheck(this, EdKnownForSlider);

    _this = _super.call(this);
    _this.glide = null;
    _this.resizeTimeout = null;
    _this.currentBreakpoint = _this.getBreakpoint();
    return _this;
  }

  _createClass(EdKnownForSlider, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.initGlide();
      this.setupResizeHandler();
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      if (this.glide) {
        this.glide.destroy();
      }

      if (this.resizeTimeout) {
        clearTimeout(this.resizeTimeout);
      }

      window.removeEventListener('resize', this.handleResize);
    }
  }, {
    key: "getBreakpoint",
    value: function getBreakpoint() {
      return window.innerWidth <= 767 ? 'mobile' : 'desktop';
    }
  }, {
    key: "setupResizeHandler",
    value: function setupResizeHandler() {
      var _this2 = this;

      this.handleResize = this.debounce(function () {
        var newBreakpoint = _this2.getBreakpoint();

        if (newBreakpoint !== _this2.currentBreakpoint) {
          _this2.currentBreakpoint = newBreakpoint;

          _this2.reinitializeGlide();
        } else {
          if (_this2.glide) {
            _this2.glide.update();
          }
        }
      }, 150);
      window.addEventListener('resize', this.handleResize);
    }
  }, {
    key: "debounce",
    value: function debounce(func, wait) {
      var _this3 = this;

      return function () {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        clearTimeout(_this3.resizeTimeout);
        _this3.resizeTimeout = setTimeout(function () {
          return func.apply(_this3, args);
        }, wait);
      };
    }
  }, {
    key: "reinitializeGlide",
    value: function reinitializeGlide() {
      if (!this.glide) return;
      var currentIndex = this.glide.index;
      this.glide.destroy();
      this.initGlide();

      if (this.glide && currentIndex < this.glide._c.Sizes.length) {
        this.glide.go('=' + currentIndex);
      }
    }
  }, {
    key: "initGlide",
    value: function initGlide() {
      var glideElement = this.querySelector('.glide');
      if (!glideElement) return;
      var totalBlocks = parseInt(this.dataset.totalBlocks) || 1;
      var desktopPerView = totalBlocks > 5 ? 5 : totalBlocks;
      var mobilePerView = totalBlocks > 3 ? 3 : totalBlocks;
      var tmItem = this.querySelector('.ed-known-for__item-tm');
      var tmIndex = tmItem ? Array.from(this.querySelectorAll('.ed-known-for__item')).indexOf(tmItem) : 0;
      this.glide = new _glidejs_glide__WEBPACK_IMPORTED_MODULE_0__["default"](glideElement, {
        type: 'carousel',
        startAt: tmIndex,
        focusAt: 'center',
        perView: desktopPerView,
        gap: 16,
        peek: {
          before: 0,
          after: 50
        },
        dragThreshold: 80,
        swipeThreshold: 80,
        autoplay: false,
        breakpoints: {
          767: {
            perView: mobilePerView,
            gap: 8,
            peek: {
              before: 0,
              after: 50
            }
          }
        }
      });

      try {
        this.glide.mount();
      } catch (error) {
        console.warn('Glide initialization failed:', error);
      }
    }
  }]);

  return EdKnownForSlider;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

customElements.define('ed-known-for-slider', EdKnownForSlider);

/***/ }),

/***/ "./src/js/modules/ed-mobile-pdp-gallery.js":
/*!*************************************************!*\
  !*** ./src/js/modules/ed-mobile-pdp-gallery.js ***!
  \*************************************************/
/***/ (() => {

var SLIDESHOW_SELECTOR = '.product-slideshow[data-product-photos]';
var MOBILE_QUERY = window.matchMedia('(max-width: 768px)');
var THUMBNAIL_WIDTH = 180;
var SETTLE_DELAY_MS = 350;
var POLL_INTERVAL_MS = 50;
var POLL_TIMEOUT_MS = 4000;
var boundInstances = new WeakSet();
var scanRafId = null;

function getFlickity(sliderElem) {
  return window.Flickity ? window.Flickity.data(sliderElem) : null;
}

function toThumbnailSrc(src) {
  if (src.includes('_{width}x.')) {
    return src.replace('_{width}x.', "_".concat(THUMBNAIL_WIDTH, "x."));
  }

  if (/_\d+x\d*\./.test(src)) {
    return src.replace(/_\d+x\d*\./, "_".concat(THUMBNAIL_WIDTH, "x."));
  }

  return src.replace(/\.(png|jpe?g|webp|gif)(?=\?|$)/i, "_".concat(THUMBNAIL_WIDTH, "x.$1"));
}

function pickImageSrc(img) {
  var loadedSrc = img.currentSrc || img.src;

  if (loadedSrc && !loadedSrc.includes('blank.gif') && !loadedSrc.startsWith('data:image')) {
    return loadedSrc;
  }

  var src = img.getAttribute('data-photoswipe-src') || img.getAttribute('data-src') || img.getAttribute('data-srcset') || '';

  if (src.includes(' ')) {
    src = src.trim().split(' ')[0];
  }

  if (!src || src.includes('blank.gif') || src.startsWith('data:image')) return null;
  return toThumbnailSrc(src);
}

function setDotThumbnails(flkty) {
  if (!flkty.pageDots || !flkty.pageDots.holder) return;
  var holder = flkty.pageDots.holder;
  holder.classList.add('ed-thumbnail-dots');
  var dots = holder.querySelectorAll('.dot');
  dots.forEach(function (dot, index) {
    var cell = flkty.cells[index];
    if (!cell || !cell.element) return;
    var img = cell.element.querySelector('img');
    if (!img) return;
    var src = pickImageSrc(img);
    if (!src) return;
    dot.style.backgroundImage = "url('".concat(src, "')");
  });
}

function scrollSelectedDotIntoView(flkty) {
  if (!flkty.pageDots || !flkty.pageDots.holder) return;
  var holder = flkty.pageDots.holder;
  var dot = holder.querySelector('.dot.is-selected');
  if (!dot || holder.scrollWidth <= holder.clientWidth) return;
  var holderRect = holder.getBoundingClientRect();
  var dotRect = dot.getBoundingClientRect();
  var left = holder.scrollLeft + (dotRect.left - holderRect.left) - (holder.clientWidth - dotRect.width) / 2;
  holder.scrollTo({
    left: Math.max(0, left),
    behavior: 'smooth'
  });
}

function bindSliderEvents(sliderElem, flkty) {
  if (boundInstances.has(flkty)) return;
  boundInstances.add(flkty);
  flkty.on('select', function () {
    setDotThumbnails(flkty);
    scrollSelectedDotIntoView(flkty);
  });
  flkty.on('change', function () {
    return setDotThumbnails(flkty);
  });
  window.setTimeout(function () {
    if (getFlickity(sliderElem) === flkty) applySlider(sliderElem);
  }, SETTLE_DELAY_MS);
}

function applySlider(sliderElem) {
  if (!MOBILE_QUERY.matches) return;
  var flkty = getFlickity(sliderElem);
  if (!flkty) return;
  flkty.options.cellAlign = 'left';
  flkty.options.percentPosition = false;
  flkty.resize();
  flkty.reposition();
  setDotThumbnails(flkty);
  scrollSelectedDotIntoView(flkty);
  bindSliderEvents(sliderElem, flkty);
}

function scanSliders() {
  if (!MOBILE_QUERY.matches) return;
  document.querySelectorAll(SLIDESHOW_SELECTOR).forEach(function (sliderElem) {
    var flkty = getFlickity(sliderElem);
    if (!flkty) return;
    var dots = sliderElem.querySelector('.flickity-page-dots');
    var transformed = dots && dots.classList.contains('ed-thumbnail-dots');
    if (!transformed || !boundInstances.has(flkty)) applySlider(sliderElem);
  });
}

function scheduleScan() {
  if (scanRafId) return;
  scanRafId = window.requestAnimationFrame(function () {
    scanRafId = null;
    scanSliders();
  });
}

function handleBreakpointChange() {
  document.querySelectorAll(SLIDESHOW_SELECTOR).forEach(function (sliderElem) {
    var flkty = getFlickity(sliderElem);
    if (!flkty) return;

    if (MOBILE_QUERY.matches) {
      applySlider(sliderElem);
    } else {
      flkty.options.cellAlign = 'center';
      flkty.options.percentPosition = true;
      flkty.resize();
    }
  });
}

function handleLazyloaded(event) {
  if (!MOBILE_QUERY.matches || !event.target.closest) return;
  var sliderElem = event.target.closest(SLIDESHOW_SELECTOR);
  if (!sliderElem) return;
  var flkty = getFlickity(sliderElem);
  if (flkty) setDotThumbnails(flkty);
}

function init() {
  scanSliders();
  new MutationObserver(scheduleScan).observe(document.body, {
    childList: true,
    subtree: true
  });
  document.addEventListener('lazyloaded', handleLazyloaded);

  if (MOBILE_QUERY.addEventListener) {
    MOBILE_QUERY.addEventListener('change', handleBreakpointChange);
  } else if (MOBILE_QUERY.addListener) {
    MOBILE_QUERY.addListener(handleBreakpointChange);
  }

  var poll = window.setInterval(function () {
    var sliderElem = document.querySelector(SLIDESHOW_SELECTOR);

    if (sliderElem && getFlickity(sliderElem)) {
      window.clearInterval(poll);
      scanSliders();
    }
  }, POLL_INTERVAL_MS);
  window.setTimeout(function () {
    return window.clearInterval(poll);
  }, POLL_TIMEOUT_MS);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

/***/ }),

/***/ "./src/js/modules/ed-more-info.js":
/*!****************************************!*\
  !*** ./src/js/modules/ed-more-info.js ***!
  \****************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var EdMoreInfo = /*#__PURE__*/function (_HTMLElement) {
  _inherits(EdMoreInfo, _HTMLElement);

  var _super = _createSuper(EdMoreInfo);

  function EdMoreInfo() {
    _classCallCheck(this, EdMoreInfo);

    return _super.apply(this, arguments);
  }

  _createClass(EdMoreInfo, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();

      this._attachListeners();

      this._checkContentAvailability();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.contentContainer = document.querySelector('.ed-product-content-container');
      this.collapsibleButton = document.querySelector('.ed-product-content button.collapsible-trigger');
      this.header = document.querySelector('#shopify-section-header');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      var _this = this;

      this.addEventListener('click', function () {
        return _this._handleClick();
      });
    }
  }, {
    key: "_handleClick",
    value: function _handleClick() {
      var _this2 = this;

      if (this.contentContainer) {
        var headerHeight = this.header ? this.header.offsetHeight : 0;
        var targetPosition = this.contentContainer.getBoundingClientRect().top + window.pageYOffset - headerHeight;
        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
        });

        if (this.collapsibleButton) {
          setTimeout(function () {
            _this2.collapsibleButton.click();
          }, 300);
        }
      }
    }
  }, {
    key: "_checkContentAvailability",
    value: function _checkContentAvailability() {
      if (!this.collapsibleButton) {
        this.classList.add('hidden');
      }
    }
  }]);

  return EdMoreInfo;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

if (!customElements.get('ed-more-info')) {
  customElements.define('ed-more-info', EdMoreInfo);
}

/***/ }),

/***/ "./src/js/modules/ed-product-suggestion.js":
/*!*************************************************!*\
  !*** ./src/js/modules/ed-product-suggestion.js ***!
  \*************************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var EdProductSuggestion = /*#__PURE__*/function (_HTMLElement) {
  _inherits(EdProductSuggestion, _HTMLElement);

  var _super = _createSuper(EdProductSuggestion);

  function EdProductSuggestion() {
    _classCallCheck(this, EdProductSuggestion);

    return _super.apply(this, arguments);
  }

  _createClass(EdProductSuggestion, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();

      this._attachListeners();

      this._init();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.suggestionElement = this.querySelector('.ed-product-suggestion');
      this.currentVariantAvailable = this.dataset.currentVariantAvailable === 'true';
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      var _this = this;

      document.addEventListener('variant:change', function (event) {
        _this.currentVariantAvailable = event.detail.variant.available;

        _this._checkVariantAvailability();
      });
    }
  }, {
    key: "_init",
    value: function _init() {
      if (!this.suggestionElement) {
        console.warn('EdProductSuggestion: No suggestion element found');
        return;
      } // Check availability immediately using data attributes


      this._checkVariantAvailability();
    }
  }, {
    key: "_checkVariantAvailability",
    value: function _checkVariantAvailability() {
      if (!this.currentVariantAvailable) {
        this._showSuggestion();
      } else {
        this._hideSuggestion();
      }
    }
  }, {
    key: "_showSuggestion",
    value: function _showSuggestion() {
      if (this.suggestionElement) {
        this.suggestionElement.style.display = 'block';
      }
    }
  }, {
    key: "_hideSuggestion",
    value: function _hideSuggestion() {
      if (this.suggestionElement) {
        this.suggestionElement.style.display = 'none';
      }
    }
  }]);

  return EdProductSuggestion;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

customElements.define('ed-product-suggestion', EdProductSuggestion);

/***/ }),

/***/ "./src/js/modules/ed-product-upsell.js":
/*!*********************************************!*\
  !*** ./src/js/modules/ed-product-upsell.js ***!
  \*********************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var SELECTORS = {
  includeCheckbox: '[data-product-upsell-include]',
  addToCart: '[data-add-to-cart]',
  qtyInput: '[data-product-upsell-qty]',
  qtyMinus: '[data-product-upsell-qty-minus]',
  qtyPlus: '[data-product-upsell-qty-plus]'
};

var EdProductUpsell = /*#__PURE__*/function (_HTMLElement) {
  _inherits(EdProductUpsell, _HTMLElement);

  var _super = _createSuper(EdProductUpsell);

  function EdProductUpsell() {
    _classCallCheck(this, EdProductUpsell);

    return _super.apply(this, arguments);
  }

  _createClass(EdProductUpsell, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.checkbox = this.querySelector(SELECTORS.includeCheckbox);
      this.qtyInput = this.querySelector(SELECTORS.qtyInput);
      this.qtyMinus = this.querySelector(SELECTORS.qtyMinus);
      this.qtyPlus = this.querySelector(SELECTORS.qtyPlus);
      this.upsellVariantId = this.dataset.upsellVariantId;
      this.form = document.querySelector('form.product-single__form');

      if (!this.checkbox || !this.upsellVariantId || !this.form) {
        return;
      }

      this._onFormSubmit = this._onFormSubmit.bind(this);
      this.form.addEventListener('submit', this._onFormSubmit, true);

      if (this.qtyInput) {
        this._attachQtyListeners();

        this._syncQtyButtons();
      }
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      if (this.form && this._onFormSubmit) {
        this.form.removeEventListener('submit', this._onFormSubmit, true);
      }
    }
  }, {
    key: "_attachQtyListeners",
    value: function _attachQtyListeners() {
      var _this$qtyMinus,
          _this = this,
          _this$qtyPlus;

      (_this$qtyMinus = this.qtyMinus) === null || _this$qtyMinus === void 0 ? void 0 : _this$qtyMinus.addEventListener('click', function (evt) {
        evt.preventDefault();

        _this._changeQty(_this._getQty() - 1);
      });
      (_this$qtyPlus = this.qtyPlus) === null || _this$qtyPlus === void 0 ? void 0 : _this$qtyPlus.addEventListener('click', function (evt) {
        evt.preventDefault();

        _this._changeQty(_this._getQty() + 1);
      });
      this.qtyInput.addEventListener('change', function () {
        _this._changeQty(_this._getQty());
      });
    }
  }, {
    key: "_getMinQty",
    value: function _getMinQty() {
      return parseInt(this.qtyInput.getAttribute('min'), 10) || 1;
    }
  }, {
    key: "_getMaxQty",
    value: function _getMaxQty() {
      var max = parseInt(this.qtyInput.getAttribute('max'), 10);
      return Number.isNaN(max) ? null : max;
    }
  }, {
    key: "_getQty",
    value: function _getQty() {
      var qty = parseInt(this.qtyInput.value, 10);
      return Number.isNaN(qty) ? this._getMinQty() : qty;
    }
  }, {
    key: "_changeQty",
    value: function _changeQty(requestedQty) {
      var qty = requestedQty;

      var minQty = this._getMinQty();

      var maxQty = this._getMaxQty();

      if (qty < minQty) {
        qty = minQty;
      }

      if (maxQty !== null && qty > maxQty) {
        qty = maxQty;
      }

      this.qtyInput.value = String(qty);

      this._syncQtyButtons();
    }
  }, {
    key: "_syncQtyButtons",
    value: function _syncQtyButtons() {
      if (!this.qtyPlus || !this.qtyMinus) {
        return;
      }

      var qty = this._getQty();

      var maxQty = this._getMaxQty();

      this.qtyMinus.disabled = this.qtyInput.disabled;
      this.qtyPlus.disabled = this.qtyInput.disabled || maxQty !== null && qty >= maxQty;
    }
  }, {
    key: "_getUpsellQuantity",
    value: function _getUpsellQuantity() {
      if (!this.qtyInput) {
        return 1;
      }

      return this._getQty();
    }
  }, {
    key: "_onFormSubmit",
    value: function _onFormSubmit(evt) {
      var _this2 = this;

      if (!this.checkbox.checked || this.checkbox.disabled) {
        return;
      }

      evt.preventDefault();
      evt.stopImmediatePropagation();
      var formData = new FormData(this.form);

      var mainLine = this._buildMainLineItem(formData);

      if (!mainLine.id) {
        return;
      }

      var addToCartBtn = this.form.querySelector(SELECTORS.addToCart);
      addToCartBtn === null || addToCartBtn === void 0 ? void 0 : addToCartBtn.classList.add('btn--loading');
      addToCartBtn === null || addToCartBtn === void 0 ? void 0 : addToCartBtn.setAttribute('disabled', 'disabled');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          items: [mainLine, {
            id: parseInt(this.upsellVariantId, 10),
            quantity: this._getUpsellQuantity()
          }]
        })
      }).then(function (response) {
        return response.json();
      }).then(function (data) {
        var _theme$settings, _theme$routes;

        if (data.status === 422) {
          _this2._dispatchError(data.description || data.message || 'Could not add to cart');

          return;
        }

        if (typeof theme !== 'undefined' && ((_theme$settings = theme.settings) === null || _theme$settings === void 0 ? void 0 : _theme$settings.cartType) === 'dropdown') {
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
            detail: {
              addToCartBtn: addToCartBtn
            }
          }));
          return;
        }

        window.location.href = typeof theme !== 'undefined' && ((_theme$routes = theme.routes) === null || _theme$routes === void 0 ? void 0 : _theme$routes.cartPage) || '/cart';
      })["catch"](function () {
        _this2._dispatchError('Network error', true);
      })["finally"](function () {
        addToCartBtn === null || addToCartBtn === void 0 ? void 0 : addToCartBtn.classList.remove('btn--loading');
        addToCartBtn === null || addToCartBtn === void 0 ? void 0 : addToCartBtn.removeAttribute('disabled');
      });
    }
  }, {
    key: "_buildMainLineItem",
    value: function _buildMainLineItem(formData) {
      var item = {
        id: parseInt(formData.get('id'), 10),
        quantity: parseInt(formData.get('quantity') || '1', 10)
      };
      var sellingPlan = formData.get('selling_plan');

      if (sellingPlan) {
        item.selling_plan = sellingPlan;
      }

      var properties = {};
      formData.forEach(function (value, key) {
        var match = key.match(/^properties\[(.+)\]$/);

        if (match) {
          properties[match[1]] = value;
        }
      });

      if (Object.keys(properties).length > 0) {
        item.properties = properties;
      }

      return item;
    }
  }, {
    key: "_dispatchError",
    value: function _dispatchError(message) {
      var uncertain = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      document.dispatchEvent(new CustomEvent('ajaxProduct:error', {
        detail: {
          errorMessage: message,
          uncertain: uncertain
        }
      }));
    }
  }]);

  return EdProductUpsell;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

if (!customElements.get('ed-product-upsell')) {
  customElements.define('ed-product-upsell', EdProductUpsell);
}

/***/ }),

/***/ "./src/js/modules/ed-recharge-subscription.js":
/*!****************************************************!*\
  !*** ./src/js/modules/ed-recharge-subscription.js ***!
  \****************************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var EdRechargeSubscription = /*#__PURE__*/function (_HTMLElement) {
  _inherits(EdRechargeSubscription, _HTMLElement);

  var _super = _createSuper(EdRechargeSubscription);

  function EdRechargeSubscription() {
    _classCallCheck(this, EdRechargeSubscription);

    return _super.apply(this, arguments);
  }

  _createClass(EdRechargeSubscription, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this = this;

      this._linkedProductUrl = this.dataset.linkedProductUrl;
      this._checkbox = this.querySelector('.ed-subscription__checkbox');
      if (this.dataset.isSubscription === 'true') this._checkbox.checked = true;

      this._findRechargeWidget();

      this._checkbox.addEventListener('change', function () {
        return _this._onToggleChange();
      }); // document.addEventListener('variant:change', () => this._onVariantChange());

    }
  }, {
    key: "_findRechargeWidget",
    value: function _findRechargeWidget() {
      var _this2 = this;

      var radioGroup = document.querySelector('.rc-radio-group__options');

      if (radioGroup) {
        this._init(radioGroup);
      } else {
        var observer = new MutationObserver(function () {
          var rg = document.querySelector('.rc-radio-group__options');

          if (rg) {
            observer.disconnect();

            _this2._init(rg);
          }
        });
        observer.observe(document.body, {
          childList: true,
          subtree: true
        });
      }
    }
  }, {
    key: "_init",
    value: function _init(radioGroup) {
      var _document$querySelect;

      this._radioGroup = radioGroup;

      this._radioGroup.classList.add('ed-rc-radio-group--hidden');

      (_document$querySelect = document.querySelector('.rc-container-wrapper .rc-widget')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.classList.add('ed-rc-hidden'); // Recharge is present on this page — reflect that in the toggle

      this._checkbox.checked = true; // --- Old: controlled Recharge radio buttons directly ---
      // this._onetimeRadio = document.querySelector('[data-radio-onetime]');
      // this._subsaveRadio = document.querySelector('[data-radio-subsave]');
      // this._applySelection();
      // this._checkbox.addEventListener('change', () => this._applySelection());
      // document.addEventListener('variant:change', () => this._onVariantChange());
    }
  }, {
    key: "_onToggleChange",
    value: function _onToggleChange() {
      window.location.href = this._linkedProductUrl;
    }
  }, {
    key: "_onVariantChange",
    value: function _onVariantChange() {
      var _this3 = this;

      // Cancel any in-flight observer/timeout from a previous variant change
      if (this._variantObserver) this._variantObserver.disconnect();
      clearTimeout(this._variantFallback);
      this._variantObserver = new MutationObserver(function () {
        var rg = document.querySelector('.rc-radio-group__options');

        if (rg) {
          var _document$querySelect2;

          _this3._variantObserver.disconnect();

          clearTimeout(_this3._variantFallback);
          _this3._radioGroup = rg;

          _this3._radioGroup.classList.add('ed-rc-radio-group--hidden');

          (_document$querySelect2 = document.querySelector('.rc-container-wrapper .rc-widget')) === null || _document$querySelect2 === void 0 ? void 0 : _document$querySelect2.classList.add('ed-rc-hidden');
          _this3._checkbox.checked = true;
        }
      });

      this._variantObserver.observe(document.body, {
        childList: true,
        subtree: true
      }); // If Recharge doesn't re-render for this variant, uncheck the toggle


      this._variantFallback = setTimeout(function () {
        _this3._variantObserver.disconnect();

        if (!document.querySelector('.rc-radio-group__options')) {
          _this3._checkbox.checked = false;
        }
      }, 2000); // --- Old: re-found radio buttons after Recharge re-render ---
      // const observer = new MutationObserver(() => {
      //     const onetime = document.querySelector('[data-radio-onetime]');
      //     const subsave = document.querySelector('[data-radio-subsave]');
      //     if (onetime && subsave) {
      //         observer.disconnect();
      //         this._onetimeRadio = onetime;
      //         this._subsaveRadio = subsave;
      //         this._applySelection();
      //     }
      // });
      // observer.observe(document.querySelector('.rc-container-wrapper') || document.body, {
      //     childList: true,
      //     subtree: true,
      // });
    } // --- Old: applied toggle state to Recharge radio buttons ---
    // _applySelection() {
    //     if (this._checkbox.checked) {
    //         this._subsaveRadio?.click();
    //     } else {
    //         this._onetimeRadio?.click();
    //     }
    // }

  }]);

  return EdRechargeSubscription;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

if (!customElements.get('ed-recharge-subscription')) {
  customElements.define('ed-recharge-subscription', EdRechargeSubscription);
}

/***/ }),

/***/ "./src/js/modules/ed-review-photos.js":
/*!********************************************!*\
  !*** ./src/js/modules/ed-review-photos.js ***!
  \********************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var IS_DESKTOP = window.matchMedia('(min-width: 769px)').matches;
var HEADER_SELECTOR = '.product-single__header';
var RATING_SNIPPET_SELECTOR = '.ruk_rating_snippet';
var RATING_COUNT_SELECTOR = '.ruk-rating-snippet-count';
var RATING_STAR_SELECTOR = '[class*="ruk-icon-percentage-star"]';
var WIDGET_ID = 'ReviewsWidget';
var PHOTO_SELECTOR = '.R-MediaSlider__item--reviewPhoto';
var PHOTO_IMAGE_SELECTOR = 'img.image__src';
var SCROLL_OFFSET = 100;
var SCAN_DELAY = 250;

var EdReviewPhotos = /*#__PURE__*/function (_HTMLElement) {
  _inherits(EdReviewPhotos, _HTMLElement);

  var _super = _createSuper(EdReviewPhotos);

  function EdReviewPhotos() {
    _classCallCheck(this, EdReviewPhotos);

    return _super.apply(this, arguments);
  }

  _createClass(EdReviewPhotos, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      if (!IS_DESKTOP) return;

      this._attachSelectors();

      if (!this.header || !this.widget) return;
      if (!this.listenersAttached) this._attachListeners();
      if (this.activated) return;
      this.observer = new MutationObserver(this._scheduleScan.bind(this));
      this.observer.observe(this.header, {
        childList: true,
        subtree: true
      });
      this.observer.observe(this.widget, {
        childList: true,
        subtree: true
      });

      this._scan();
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      this._stop();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.header = this.closest(HEADER_SELECTOR);
      this.widget = document.getElementById(WIDGET_ID);
      this.starsElem = this.querySelector('[data-review-photos-stars]');
      this.countElem = this.querySelector('[data-review-photos-count]');
      this.gridElem = this.querySelector('[data-review-photos-grid]');
      this.scrollTriggers = this.querySelectorAll('[data-review-photos-scroll]');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      var _this = this;

      this.listenersAttached = true;
      this.handleScrollToReviews = this.handleScrollToReviews.bind(this);
      this.scrollTriggers.forEach(function (trigger) {
        trigger.addEventListener('click', _this.handleScrollToReviews);
      });
    }
  }, {
    key: "_stop",
    value: function _stop() {
      if (this.observer) this.observer.disconnect();
      window.clearTimeout(this.scanTimer);
      this.observer = null;
      this.scanTimer = null;
    }
  }, {
    key: "_scheduleScan",
    value: function _scheduleScan() {
      var _this2 = this;

      if (this.scanTimer) return;
      this.scanTimer = window.setTimeout(function () {
        _this2.scanTimer = null;

        _this2._scan();
      }, SCAN_DELAY);
    }
  }, {
    key: "_scan",
    value: function _scan() {
      if (!this.photosRendered) this._renderPhotos();
      if (this.photosRendered && !this.activated) this._activate();
      if (this.activated) this._stop();
    }
  }, {
    key: "_activate",
    value: function _activate() {
      var _this3 = this;

      var snippet = this.header.querySelector(RATING_SNIPPET_SELECTOR);
      var countElem = snippet && snippet.querySelector(RATING_COUNT_SELECTOR);
      var count = countElem && countElem.textContent.match(/[\d.,]+/);
      var stars = snippet ? snippet.querySelectorAll(RATING_STAR_SELECTOR) : [];
      if (!count || !stars.length) return;
      stars.forEach(function (star) {
        return _this3.starsElem.appendChild(star.cloneNode(true));
      });
      this.countElem.textContent = "(".concat(count[0], ")");
      this.hidden = false;
      this.classList.add('ed-review-photos--active');
      this.activated = true;
    }
  }, {
    key: "_renderPhotos",
    value: function _renderPhotos() {
      var _this4 = this;

      var photoNodes = Array.from(this.widget.querySelectorAll(PHOTO_SELECTOR));
      var total = photoNodes.length;
      var showMax = total === 5 ? 5 : 4;
      var visibleNodes = photoNodes.slice(0, showMax);
      var images = visibleNodes.map(function (node) {
        return node.querySelector(PHOTO_IMAGE_SELECTOR);
      });
      if (!total || images.some(function (image) {
        return !image || !image.src;
      })) return;
      var fragment = document.createDocumentFragment();
      visibleNodes.forEach(function (node, index) {
        var tile = _this4._createTile('ed-review-photos__tile', function () {
          return node.click();
        });

        var image = document.createElement('img');
        image.className = 'ed-review-photos__image';
        image.src = images[index].src;
        image.alt = images[index].alt || '';
        image.decoding = 'async';
        tile.appendChild(image);
        fragment.appendChild(tile);
      });

      if (total > 5) {
        var more = this._createTile('ed-review-photos__tile ed-review-photos__more', this.handleScrollToReviews);

        more.textContent = "+".concat(total - 4);
        fragment.appendChild(more);
      }

      this.gridElem.appendChild(fragment);
      this.gridElem.hidden = false;
      this.photosRendered = true;
    }
  }, {
    key: "_createTile",
    value: function _createTile(className, onClick) {
      var tile = document.createElement('button');
      tile.type = 'button';
      tile.className = className;
      tile.addEventListener('click', onClick);
      return tile;
    }
  }, {
    key: "handleScrollToReviews",
    value: function handleScrollToReviews() {
      var top = this.widget.getBoundingClientRect().top + window.pageYOffset - SCROLL_OFFSET;
      window.scrollTo({
        top: top,
        behavior: 'smooth'
      });
    }
  }]);

  return EdReviewPhotos;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

if (!customElements.get('ed-review-photos')) {
  customElements.define('ed-review-photos', EdReviewPhotos);
}

/***/ }),

/***/ "./src/js/modules/ed-upsell-popup.js":
/*!*******************************************!*\
  !*** ./src/js/modules/ed-upsell-popup.js ***!
  \*******************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var SELECTORS = {
  mainForm: '[data-section-type="product"] form.product-single__form',
  dialog: '[role="dialog"]',
  items: '[data-upsell-item]',
  add: '[data-upsell-add]',
  remove: '[data-upsell-remove]',
  close: '[data-upsell-close]',
  continueButton: '[data-upsell-continue]',
  variant: '[data-upsell-variant]',
  priceCurrent: '[data-upsell-price-current]',
  priceCompare: '[data-upsell-price-compare]',
  error: '[data-upsell-error]',
  pageContainer: '#PageContainer',
  cartBubble: '.cart-link__bubble',
  cartBubbleNum: '.cart-link__bubble-num',
  variantJson: '[data-variant-json]',
  variantSelect: 'select[name="id"]',
  focusable: 'button:not([disabled]), a[href], select:not([disabled]), [tabindex]:not([tabindex="-1"])'
};
var STORAGE_KEY = 'edUpsellPopupViews';
var LINE_PROPERTY = '_ed_upsell_popup';
var ADD_TIMEOUT = 10000;
var CART_TIMEOUT = 5000;
var INLINE_SUBMIT_TIMEOUT = 15000;

function requestFailure(uncertain) {
  var error = new Error(uncertain ? 'request outcome unknown' : 'request failed');
  error.uncertain = uncertain;
  return error;
}

function requestJson(url, options, timeout) {
  var controller = typeof AbortController === 'function' ? new AbortController() : null;
  var config = Object.assign({
    credentials: 'same-origin'
  }, options);

  if (controller) {
    config.signal = controller.signal;
  }

  var timer = setTimeout(function () {
    return controller && controller.abort();
  }, timeout);
  return fetch(url, config).then(function (response) {
    return response.json().then(function (data) {
      return {
        ok: response.ok,
        status: response.status,
        data: data
      };
    }, function () {
      throw requestFailure(true);
    });
  }, function () {
    throw requestFailure(true);
  })["finally"](function () {
    return clearTimeout(timer);
  });
}

function isDefinitiveRejection(result) {
  return !result.ok && result.status >= 400 && result.status < 500;
}

var EdUpsellPopup = /*#__PURE__*/function (_HTMLElement) {
  _inherits(EdUpsellPopup, _HTMLElement);

  var _super = _createSuper(EdUpsellPopup);

  function EdUpsellPopup() {
    _classCallCheck(this, EdUpsellPopup);

    return _super.apply(this, arguments);
  }

  _createClass(EdUpsellPopup, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();

      if (!this.form || !this.dialog || !this.items.length || !this.continueButton) {
        return;
      }

      this._attachListeners();
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      if (this._onSubmit) {
        document.removeEventListener('submit', this._onSubmit, true);
      }

      if (this._onKeydown) {
        document.removeEventListener('keydown', this._onKeydown);
      }
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.form = document.querySelector(SELECTORS.mainForm);
      this.dialog = this.querySelector(SELECTORS.dialog);
      this.items = Array.from(this.querySelectorAll(SELECTORS.items));
      this.continueButton = this.querySelector(SELECTORS.continueButton);
      this.pageContainer = document.querySelector(SELECTORS.pageContainer);
      this.cartUrl = this.dataset.cartUrl || '/cart';
      this.sessionLimit = parseInt(this.dataset.sessionLimit, 10) || 0;
      this.isOpen = false;
      this.bypass = false;
      this.leaving = false;
      this.imagesLoaded = false;
      this.pendingAdd = null;
      this.lastCart = null;
      this.submitStalled = false;
      this.inlineSubmitTimer = null;
      this.submitSnapshot = null;
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      var _this = this;

      this._onSubmit = this._onSubmit.bind(this);
      this._onKeydown = this._onKeydown.bind(this);
      document.addEventListener('submit', this._onSubmit, true);
      this.querySelectorAll(SELECTORS.close).forEach(function (element) {
        element.addEventListener('click', function () {
          return _this._leave('close');
        });
      });
      this.continueButton.addEventListener('click', function () {
        return _this._leave('continue');
      });
      this.items.forEach(function (item) {
        var addButton = item.querySelector(SELECTORS.add);
        var removeButton = item.querySelector(SELECTORS.remove);
        var select = item.querySelector(SELECTORS.variant);

        if (addButton) {
          item.dataset.addLabel = addButton.textContent.trim();
          addButton.addEventListener('click', function () {
            return _this._addItem(item);
          });
        }

        if (removeButton) {
          removeButton.addEventListener('click', function () {
            return _this._removeItem(item);
          });
        }

        if (select) {
          select.addEventListener('change', function () {
            return _this._syncVariant(item);
          });
        }
      });
      document.addEventListener('ajaxProduct:error', function (evt) {
        return _this._onSubmitError(evt);
      });
      window.addEventListener('pageshow', function (evt) {
        if (evt.persisted) {
          _this._reset();
        }
      });
    }
  }, {
    key: "_onSubmit",
    value: function _onSubmit(evt) {
      if (evt.target !== this.form || this.bypass) {
        return;
      }

      if (this.isOpen) {
        evt.preventDefault();
        return;
      }

      var visibleItems;

      try {
        if (typeof theme !== 'undefined' && theme.settings && theme.settings.cartType === 'dropdown') {
          return;
        }

        if (this._limitReached()) {
          return;
        }

        if (typeof this.form.requestSubmit !== 'function' && this._inlineUpsellChecked()) {
          return;
        }

        this._hideInlineUpsellDuplicate();

        visibleItems = this._visibleItems();

        if (!visibleItems.length) {
          return;
        }
      } catch (error) {
        return;
      }

      evt.preventDefault();
      evt.stopImmediatePropagation();

      this._open(visibleItems);
    }
  }, {
    key: "_open",
    value: function _open(visibleItems) {
      try {
        this._loadImages();

        this.hidden = false;
        this.isOpen = true;
        this.leaving = false;
        document.body.classList.add('ed-upsell-popup-open');

        if (this.pageContainer) {
          this.pageContainer.setAttribute('inert', '');
          this.pageContainer.setAttribute('aria-hidden', 'true');
        }

        document.addEventListener('keydown', this._onKeydown);

        this._countView();

        this._track('view', visibleItems);

        this._focusFirst();

        this._hideItemsAlreadyInCart();
      } catch (error) {
        this._leave('error');
      }
    }
  }, {
    key: "_hideInlineUpsellDuplicate",
    value: function _hideInlineUpsellDuplicate() {
      var inline = document.querySelector('ed-product-upsell');
      var checkbox = inline && inline.querySelector('[data-product-upsell-include]');

      if (!checkbox || !checkbox.checked || checkbox.disabled) {
        return;
      }

      var inlineProductId = inline.dataset.upsellProductId || '';
      var inlineVariantId = inline.dataset.upsellVariantId || '';
      this.items.forEach(function (item) {
        var variantIds = [item.dataset.variantId].concat(Array.from(item.querySelectorAll('option')).map(function (option) {
          return option.value;
        }));
        var sameProduct = inlineProductId && item.dataset.productId === inlineProductId;
        var sameVariant = inlineVariantId && variantIds.includes(inlineVariantId);

        if (sameProduct || sameVariant) {
          item.hidden = true;
        }
      });
    }
  }, {
    key: "_hideItemsAlreadyInCart",
    value: function _hideItemsAlreadyInCart() {
      var _this2 = this;

      requestJson('/cart.js', {
        method: 'GET'
      }, CART_TIMEOUT).then(function (_ref) {
        var cart = _ref.data;
        _this2.lastCart = cart;
        var productIds = new Set((cart.items || []).map(function (line) {
          return line.product_id;
        }));

        _this2.items.forEach(function (item) {
          if (productIds.has(Number(item.dataset.productId)) && !item.classList.contains('is-added')) {
            item.hidden = true;
          }
        });

        if (_this2.isOpen && !_this2._visibleItems().length) {
          _this2._leave('continue');

          return;
        }

        if (_this2.isOpen) {
          _this2._ensureFocusVisible();
        }
      })["catch"](function () {});
    }
  }, {
    key: "_visibleItems",
    value: function _visibleItems() {
      return this.items.filter(function (item) {
        return !item.hidden;
      });
    }
  }, {
    key: "_loadImages",
    value: function _loadImages() {
      if (this.imagesLoaded) {
        return;
      }

      this.imagesLoaded = true;
      this.querySelectorAll('img[data-src]').forEach(function (img) {
        img.src = img.dataset.src;
        img.removeAttribute('data-src');
      });
    }
  }, {
    key: "_focusFirst",
    value: function _focusFirst() {
      var target = this.dialog.querySelector(SELECTORS.items + ':not([hidden]) ' + SELECTORS.add + ':not([disabled])') || this.continueButton;
      target.focus();
    }
  }, {
    key: "_ensureFocusVisible",
    value: function _ensureFocusVisible() {
      var active = document.activeElement;
      var activeItem = active && active.closest ? active.closest(SELECTORS.items) : null;

      if (!this.dialog.contains(active) || activeItem && activeItem.hidden) {
        this._focusFirst();
      }
    }
  }, {
    key: "_onKeydown",
    value: function _onKeydown(evt) {
      if (!this.isOpen) {
        return;
      }

      if (evt.key === 'Escape') {
        evt.preventDefault();

        this._leave('close');

        return;
      }

      if (evt.key !== 'Tab') {
        return;
      }

      var focusable = Array.from(this.dialog.querySelectorAll(SELECTORS.focusable)).filter(function (el) {
        return el.offsetParent !== null;
      });

      if (!focusable.length) {
        return;
      }

      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (evt.shiftKey && (document.activeElement === first || !this.dialog.contains(document.activeElement))) {
        evt.preventDefault();
        last.focus();
      } else if (!evt.shiftKey && (document.activeElement === last || !this.dialog.contains(document.activeElement))) {
        evt.preventDefault();
        first.focus();
      }
    }
  }, {
    key: "_selectedVariant",
    value: function _selectedVariant(item) {
      var select = item.querySelector(SELECTORS.variant);

      if (select && select.selectedIndex >= 0) {
        var option = select.options[select.selectedIndex];
        return {
          id: parseInt(option.value, 10),
          price: parseInt(option.dataset.price, 10) || 0,
          title: option.textContent.trim()
        };
      }

      return {
        id: parseInt(item.dataset.variantId, 10),
        price: parseInt(item.dataset.price, 10) || 0,
        title: item.dataset.variantTitle || ''
      };
    }
  }, {
    key: "_syncVariant",
    value: function _syncVariant(item) {
      var select = item.querySelector(SELECTORS.variant);
      var option = select.options[select.selectedIndex];
      var current = item.querySelector(SELECTORS.priceCurrent);
      var compare = item.querySelector(SELECTORS.priceCompare);

      if (current && option.dataset.priceFormatted) {
        current.textContent = option.dataset.priceFormatted;
      }

      if (compare) {
        if (option.dataset.compareFormatted) {
          compare.textContent = option.dataset.compareFormatted;
          compare.hidden = false;
        } else {
          compare.hidden = true;
        }
      }
    }
  }, {
    key: "_addItem",
    value: function _addItem(item) {
      var _this3 = this;

      if (this.pendingAdd || this.leaving || this.submitStalled) {
        return;
      }

      var button = item.querySelector(SELECTORS.add);
      var select = item.querySelector(SELECTORS.variant);
      var errorElement = item.querySelector(SELECTORS.error);

      var variant = this._selectedVariant(item);

      if (!variant.id || !button) {
        return;
      }

      button.disabled = true;
      button.classList.add('is-loading');

      if (select) {
        select.disabled = true;
      }

      if (errorElement) {
        errorElement.hidden = true;
      }

      var markAdded = function markAdded() {
        item.classList.add('is-added');
        item.dataset.addedVariantId = String(variant.id);
        button.textContent = _this3.dataset.textAdded;
        button.setAttribute('aria-disabled', 'true');
        var removeButton = item.querySelector(SELECTORS.remove);

        if (removeButton) {
          removeButton.hidden = false;
          removeButton.disabled = false;
        }

        _this3._track('add', [item], variant);

        return _this3._syncCart();
      };

      var showMessage = function showMessage(text) {
        if (errorElement) {
          errorElement.textContent = text;
          errorElement.hidden = false;
        }
      };

      var showError = function showError() {
        button.disabled = false;

        if (select) {
          select.disabled = false;
        }

        showMessage(_this3.dataset.textError);
      };

      var lockUnknown = function lockUnknown() {
        button.disabled = true;
        showMessage(_this3.dataset.textUnknown);
      };

      var reconcile = function reconcile(quantityBefore) {
        return _this3._reconcileAdd(variant.id, quantityBefore).then(function (confirmed) {
          if (confirmed) {
            return markAdded();
          }

          lockUnknown();
          return null;
        });
      };

      this.pendingAdd = this._baselineQuantity(variant.id).then(function (quantityBefore) {
        return requestJson('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            items: [{
              id: variant.id,
              quantity: 1,
              properties: _this3._lineProperties()
            }]
          })
        }, ADD_TIMEOUT).then(function (result) {
          if (result.ok && !result.data.status) {
            return markAdded();
          }

          if (isDefinitiveRejection(result)) {
            showError();
            return null;
          }

          return reconcile(quantityBefore);
        }, function (error) {
          if (error && error.uncertain) {
            return reconcile(quantityBefore);
          }

          showError();
          return null;
        });
      })["catch"](lockUnknown)["finally"](function () {
        button.classList.remove('is-loading');
        _this3.pendingAdd = null;
      });
    }
  }, {
    key: "_removeItem",
    value: function _removeItem(item) {
      var _this4 = this;

      if (this.pendingAdd || this.leaving || this.submitStalled || !item.classList.contains('is-added')) {
        return;
      }

      var button = item.querySelector(SELECTORS.add);
      var removeButton = item.querySelector(SELECTORS.remove);
      var select = item.querySelector(SELECTORS.variant);
      var errorElement = item.querySelector(SELECTORS.error);
      var variantId = parseInt(item.dataset.addedVariantId, 10);

      if (!variantId || !removeButton) {
        return;
      }

      removeButton.disabled = true;
      removeButton.classList.add('is-loading');

      if (errorElement) {
        errorElement.hidden = true;
      }

      var showMessage = function showMessage(text) {
        if (errorElement) {
          errorElement.textContent = text;
          errorElement.hidden = false;
        }
      };

      var restore = function restore() {
        item.classList.remove('is-added');
        delete item.dataset.addedVariantId;
        button.textContent = item.dataset.addLabel || button.textContent;
        button.removeAttribute('aria-disabled');
        button.disabled = false;

        if (select) {
          select.disabled = false;
        }

        removeButton.hidden = true;

        var variant = _this4._selectedVariant(item);

        _this4._track('remove', [item], {
          id: variantId,
          price: variant.price,
          title: variant.title
        });

        return _this4._syncCart();
      };

      var keepAdded = function keepAdded() {
        removeButton.disabled = false;
        showMessage(_this4.dataset.textRemoveError || _this4.dataset.textError);
      };

      var lockUnknown = function lockUnknown() {
        removeButton.disabled = true;
        showMessage(_this4.dataset.textUnknown);
      };

      var isPopupLine = function isPopupLine(line) {
        return line.variant_id === variantId && !line.selling_plan_allocation && _this4._isPopupLine(line);
      };

      var resolveTarget = function resolveTarget(cart) {
        var lines = cart.items.filter(isPopupLine);

        if (lines.length === 0) {
          return {
            gone: true
          };
        }

        if (lines.length > 1) {
          return null;
        }

        return {
          id: lines[0].key,
          quantity: Math.max(lines[0].quantity - 1, 0)
        };
      };

      var verify = function verify(target) {
        return _this4._readCart().then(function (cartNow) {
          if (!cartNow) {
            lockUnknown();
            return null;
          }

          var lines = cartNow.items.filter(isPopupLine);

          if (lines.length > 1) {
            lockUnknown();
            return null;
          }

          var quantityNow = lines.length ? lines[0].quantity : 0;

          if (Number.isFinite(quantityNow) && quantityNow === target.quantity) {
            return restore();
          }

          lockUnknown();
          return null;
        });
      };

      this.pendingAdd = this._readCart().then(function (cart) {
        if (!cart) {
          keepAdded();
          return null;
        }

        var target = resolveTarget(cart);

        if (!target) {
          lockUnknown();
          return null;
        }

        if (target.gone) {
          return restore();
        }

        return requestJson('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            id: target.id,
            quantity: target.quantity
          })
        }, ADD_TIMEOUT).then(function (result) {
          if (result.ok && !result.data.status && Array.isArray(result.data.items)) {
            _this4.lastCart = result.data;
            return restore();
          }

          if (isDefinitiveRejection(result)) {
            keepAdded();
            return null;
          }

          return verify(target);
        }, function (error) {
          if (error && error.uncertain) {
            return verify(target);
          }

          keepAdded();
          return null;
        });
      })["catch"](lockUnknown)["finally"](function () {
        removeButton.classList.remove('is-loading');
        _this4.pendingAdd = null;
      });
    }
  }, {
    key: "_lineProperties",
    value: function _lineProperties() {
      var properties = {};
      properties[LINE_PROPERTY] = this.dataset.triggerHandle || 'popup';
      return properties;
    }
  }, {
    key: "_isPopupLine",
    value: function _isPopupLine(line) {
      var properties = line.properties || {};
      var keys = Object.keys(properties);
      return keys.length === 1 && keys[0] === LINE_PROPERTY && properties[LINE_PROPERTY] === (this.dataset.triggerHandle || 'popup');
    }
  }, {
    key: "_readCart",
    value: function _readCart() {
      var _this5 = this;

      return requestJson('/cart.js', {
        method: 'GET'
      }, CART_TIMEOUT).then(function (_ref2) {
        var ok = _ref2.ok,
            cart = _ref2.data;

        if (!ok || !cart || !Array.isArray(cart.items)) {
          return null;
        }

        _this5.lastCart = cart;
        return cart;
      })["catch"](function () {
        return null;
      });
    }
  }, {
    key: "_cartQuantity",
    value: function _cartQuantity(cart, variantId) {
      var _this6 = this;

      if (!cart || !Array.isArray(cart.items)) {
        return null;
      }

      var lines = cart.items.filter(function (line) {
        return line.variant_id === variantId && _this6._isPopupLine(line);
      });

      if (lines.some(function (line) {
        return !Number.isFinite(line.quantity);
      })) {
        return null;
      }

      return lines.reduce(function (sum, line) {
        return sum + line.quantity;
      }, 0);
    }
  }, {
    key: "_baselineQuantity",
    value: function _baselineQuantity(variantId) {
      var _this7 = this;

      if (this.lastCart) {
        return Promise.resolve(this._cartQuantity(this.lastCart, variantId));
      }

      return requestJson('/cart.js', {
        method: 'GET'
      }, CART_TIMEOUT).then(function (_ref3) {
        var ok = _ref3.ok,
            cart = _ref3.data;

        if (!ok || !cart || !Array.isArray(cart.items)) {
          return null;
        }

        _this7.lastCart = cart;
        return _this7._cartQuantity(cart, variantId);
      })["catch"](function () {
        return null;
      });
    }
  }, {
    key: "_reconcileAdd",
    value: function _reconcileAdd(variantId, quantityBefore) {
      var _this8 = this;

      if (typeof quantityBefore !== 'number') {
        return Promise.resolve(false);
      }

      return requestJson('/cart.js', {
        method: 'GET'
      }, CART_TIMEOUT).then(function (_ref4) {
        var ok = _ref4.ok,
            cart = _ref4.data;

        if (!ok || !cart || !Array.isArray(cart.items)) {
          return false;
        }

        _this8.lastCart = cart;

        var quantityAfter = _this8._cartQuantity(cart, variantId);

        return typeof quantityAfter === 'number' && quantityAfter > quantityBefore;
      })["catch"](function () {
        return false;
      });
    }
  }, {
    key: "_syncCart",
    value: function _syncCart() {
      var _this9 = this;

      return requestJson('/cart.js', {
        method: 'GET'
      }, CART_TIMEOUT).then(function (_ref5) {
        var cart = _ref5.data;
        _this9.lastCart = cart;

        _this9._updateBubble(cart.item_count);

        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: {
            cart: cart,
            variant: _this9._currentFormVariant()
          }
        }));
      })["catch"](function () {});
    }
  }, {
    key: "_currentFormVariant",
    value: function _currentFormVariant() {
      try {
        var json = this.form.querySelector(SELECTORS.variantJson);
        var select = this.form.querySelector(SELECTORS.variantSelect);

        if (!json || !select) {
          return null;
        }

        var variants = JSON.parse(json.value || json.textContent);
        var id = parseInt(select.value, 10);
        return variants.find(function (variant) {
          return variant.id === id;
        }) || null;
      } catch (error) {
        return null;
      }
    }
  }, {
    key: "_updateBubble",
    value: function _updateBubble(count) {
      document.querySelectorAll(SELECTORS.cartBubbleNum).forEach(function (el) {
        el.textContent = count;
      });
      document.querySelectorAll(SELECTORS.cartBubble).forEach(function (bubble) {
        bubble.classList.toggle('cart-link__bubble--visible', count > 0);
      });
    }
  }, {
    key: "_leave",
    value: function _leave(reason) {
      var _this10 = this;

      if (this.leaving) {
        return;
      }

      if (this.submitStalled) {
        var goToCart = function goToCart() {
          window.location.href = _this10.cartUrl;
        };

        if (this.pendingAdd) {
          this.pendingAdd.then(goToCart, goToCart);
        } else {
          goToCart();
        }

        return;
      }

      this.leaving = true;

      if (reason === 'continue' || reason === 'close') {
        this._track(reason);
      }

      this.continueButton.classList.add('is-loading');
      this.continueButton.disabled = true;

      var submit = function submit() {
        if (!_this10._inlineUpsellChecked()) {
          _this10._submitForm();

          return;
        }

        _this10._snapshotCart().then(function () {
          return _this10._submitForm();
        }, function () {
          return _this10._submitForm();
        });
      };

      if (this.pendingAdd) {
        this.pendingAdd.then(submit, submit);
        return;
      }

      submit();
    }
  }, {
    key: "_snapshotCart",
    value: function _snapshotCart() {
      var _this11 = this;

      this.submitSnapshot = null;
      return requestJson('/cart.js', {
        method: 'GET'
      }, CART_TIMEOUT).then(function (_ref6) {
        var ok = _ref6.ok,
            cart = _ref6.data;

        if (ok && cart && Array.isArray(cart.items)) {
          _this11.submitSnapshot = cart;
          _this11.lastCart = cart;
        }
      });
    }
  }, {
    key: "_cartChangedSinceSnapshot",
    value: function _cartChangedSinceSnapshot() {
      var _this12 = this;

      var snapshot = this.submitSnapshot;

      if (!snapshot) {
        return Promise.resolve(true);
      }

      var signature = function signature(cart) {
        return cart.items.map(function (line) {
          return line.variant_id + ':' + line.quantity;
        }).sort().join('|');
      };

      return requestJson('/cart.js', {
        method: 'GET'
      }, CART_TIMEOUT).then(function (_ref7) {
        var ok = _ref7.ok,
            cart = _ref7.data;

        if (!ok || !cart || !Array.isArray(cart.items)) {
          return true;
        }

        _this12.lastCart = cart;
        return signature(cart) !== signature(snapshot);
      })["catch"](function () {
        return true;
      });
    }
  }, {
    key: "_submitForm",
    value: function _submitForm() {
      var inlineUpsellActive = this._inlineUpsellChecked();

      this.bypass = true;

      try {
        if (typeof this.form.requestSubmit === 'function') {
          this.form.requestSubmit();
        } else {
          this.form.submit();
        }
      } catch (error) {
        this.form.submit();
      }

      this.bypass = false;

      if (inlineUpsellActive) {
        this._armInlineSubmitTimeout();
      }
    }
  }, {
    key: "_inlineUpsellChecked",
    value: function _inlineUpsellChecked() {
      var checkbox = document.querySelector('ed-product-upsell [data-product-upsell-include]');
      return !!(checkbox && checkbox.checked && !checkbox.disabled);
    }
  }, {
    key: "_armInlineSubmitTimeout",
    value: function _armInlineSubmitTimeout() {
      var _this13 = this;

      clearTimeout(this.inlineSubmitTimer);
      this.inlineSubmitTimer = setTimeout(function () {
        if (_this13.leaving) {
          _this13._enterStalledState();
        }
      }, INLINE_SUBMIT_TIMEOUT);
    }
  }, {
    key: "_enterStalledState",
    value: function _enterStalledState() {
      this.submitStalled = true;

      this._resetLeaving();

      this.items.forEach(function (item) {
        var button = item.querySelector(SELECTORS.add);
        var removeButton = item.querySelector(SELECTORS.remove);

        if (button && !item.classList.contains('is-added')) {
          button.disabled = true;
        }

        if (removeButton) {
          removeButton.disabled = true;
        }
      });
      this.continueButton.focus();
    }
  }, {
    key: "_resetLeaving",
    value: function _resetLeaving() {
      clearTimeout(this.inlineSubmitTimer);

      if (!this.leaving) {
        return;
      }

      this.leaving = false;
      this.continueButton.classList.remove('is-loading');
      this.continueButton.disabled = false;
    }
  }, {
    key: "_onSubmitError",
    value: function _onSubmitError(evt) {
      var _this14 = this;

      if (!this.leaving) {
        return;
      }

      if (evt.detail && evt.detail.uncertain) {
        this._enterStalledState();

        return;
      }

      var message = evt.detail && evt.detail.errorMessage;

      this._cartChangedSinceSnapshot().then(function (changed) {
        if (changed) {
          _this14._enterStalledState();

          return;
        }

        _this14._reset();

        _this14._showFormError(message);

        var addToCart = _this14.form.querySelector('[data-add-to-cart]');

        if (addToCart) {
          setTimeout(function () {
            return addToCart.focus();
          }, 0);
        }
      });
    }
  }, {
    key: "_showFormError",
    value: function _showFormError(message) {
      var existing = this.form.querySelector('.errors');

      if (existing) {
        existing.remove();
      }

      if (!message) {
        return;
      }

      var errors = document.createElement('div');
      errors.classList.add('errors', 'text-center');
      errors.setAttribute('role', 'alert');
      errors.textContent = message;
      this.form.append(errors);
    }
  }, {
    key: "_reset",
    value: function _reset() {
      this.hidden = true;
      this.isOpen = false;
      this.bypass = false;
      this.submitStalled = false;

      this._resetLeaving();

      document.body.classList.remove('ed-upsell-popup-open');

      if (this.pageContainer) {
        this.pageContainer.removeAttribute('inert');
        this.pageContainer.removeAttribute('aria-hidden');
      }

      document.removeEventListener('keydown', this._onKeydown);
    }
  }, {
    key: "_limitReached",
    value: function _limitReached() {
      if (!this.sessionLimit) {
        return false;
      }

      return this._views() >= this.sessionLimit;
    }
  }, {
    key: "_views",
    value: function _views() {
      try {
        return parseInt(sessionStorage.getItem(STORAGE_KEY), 10) || 0;
      } catch (error) {
        return 0;
      }
    }
  }, {
    key: "_countView",
    value: function _countView() {
      try {
        sessionStorage.setItem(STORAGE_KEY, String(this._views() + 1));
      } catch (error) {// storage may be unavailable in private mode; the popup still shows
      }
    }
  }, {
    key: "_track",
    value: function _track(name, items, submittedVariant) {
      var _this15 = this;

      try {
        window.dataLayer = window.dataLayer || [];
        var payload = {
          event: 'ed_upsell_popup_' + name,
          ed_upsell: {
            source: this.dataset.source,
            trigger_product_id: this.dataset.triggerProductId,
            trigger_handle: this.dataset.triggerHandle,
            trigger_title: this.dataset.triggerTitle
          }
        };

        if (items && items.length) {
          var ecommerceItems = items.map(function (item) {
            var variant = submittedVariant || _this15._selectedVariant(item);

            return {
              item_id: String(variant.id),
              item_name: item.dataset.title,
              item_variant: variant.title,
              price: variant.price / 100,
              quantity: 1
            };
          });
          payload.ecommerce = {
            currency: this.dataset.currency,
            value: Math.round(ecommerceItems.reduce(function (sum, entry) {
              return sum + entry.price;
            }, 0) * 100) / 100,
            items: ecommerceItems
          };
          window.dataLayer.push({
            ecommerce: null
          });
        }

        window.dataLayer.push(payload);
      } catch (error) {// tracking must never affect the purchase flow
      }
    }
  }]);

  return EdUpsellPopup;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

if (!customElements.get('ed-upsell-popup')) {
  customElements.define('ed-upsell-popup', EdUpsellPopup);
}

/***/ }),

/***/ "./src/js/modules/ed-variant-delivery-label.js":
/*!*****************************************************!*\
  !*** ./src/js/modules/ed-variant-delivery-label.js ***!
  \*****************************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var EdVariantDeliveryLabel = /*#__PURE__*/function (_HTMLElement) {
  _inherits(EdVariantDeliveryLabel, _HTMLElement);

  var _super = _createSuper(EdVariantDeliveryLabel);

  function EdVariantDeliveryLabel() {
    _classCallCheck(this, EdVariantDeliveryLabel);

    return _super.apply(this, arguments);
  }

  _createClass(EdVariantDeliveryLabel, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();

      this._attachListeners();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.standardLabel = this.dataset.standardLabel || '';
      this.labels = this._readLabels();
      this.scope = this.closest('form.product-single__form') || document;
      this.availableEta = this.scope.querySelector('.ed-shipping-eta.available');
      this.soldOutEta = this.scope.querySelector('.shipping-eta.soldout');
    }
  }, {
    key: "_readLabels",
    value: function _readLabels() {
      var island = this.querySelector('[data-ed-delivery-labels]');

      if (!island) {
        return {};
      }

      try {
        return JSON.parse(island.textContent);
      } catch (error) {
        return {};
      }
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      document.addEventListener('variant:change', this.handleVariantChange.bind(this));
    }
  }, {
    key: "handleVariantChange",
    value: function handleVariantChange(event) {
      var variant = event.detail && event.detail.variant;

      if (!variant) {
        return;
      }

      var entry = this.labels[variant.id];

      var eventLabel = this._cleanLabel(event.detail && event.detail.deliveryLabel);

      var label = eventLabel || (entry ? entry.label : this.standardLabel);

      if (this.availableEta && label) {
        this.availableEta.textContent = label;
      }

      if (this.soldOutEta && entry) {
        this.soldOutEta.textContent = entry.soldOut;
      }

      this._toggleAvailability(Boolean(variant.available));
    }
  }, {
    key: "_toggleAvailability",
    value: function _toggleAvailability(isAvailable) {
      if (this.availableEta) {
        this.availableEta.style.display = isAvailable ? 'block' : 'none';
      }

      if (this.soldOutEta) {
        this.soldOutEta.style.display = isAvailable ? 'none' : 'block';
      }
    }
  }, {
    key: "_cleanLabel",
    value: function _cleanLabel(value) {
      if (typeof value !== 'string') {
        return '';
      }

      var cleaned = value.trim();
      return cleaned === 'undefined' ? '' : cleaned;
    }
  }]);

  return EdVariantDeliveryLabel;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

if (!customElements.get('ed-variant-delivery-label')) {
  customElements.define('ed-variant-delivery-label', EdVariantDeliveryLabel);
}

/***/ }),

/***/ "./src/js/modules/ed-video-component.js":
/*!**********************************************!*\
  !*** ./src/js/modules/ed-video-component.js ***!
  \**********************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var EdVideoThumbnail = /*#__PURE__*/function (_HTMLElement) {
  _inherits(EdVideoThumbnail, _HTMLElement);

  var _super = _createSuper(EdVideoThumbnail);

  function EdVideoThumbnail() {
    var _this;

    _classCallCheck(this, EdVideoThumbnail);

    _this = _super.call(this);

    _this._attachSelectors();

    _this._attachListeners(); // ENABLE EXTERNAL POPUP ELEMENT


    if (_this.popUp) {
      document.querySelector('ed-video-popup').setAttribute('enabled', '');
    }

    return _this;
  }

  _createClass(EdVideoThumbnail, [{
    key: "videoSrc",
    get: function get() {
      return this.getAttribute('video-src');
    }
  }, {
    key: "autoPlay",
    get: function get() {
      return this.getAttribute('autoplay');
    }
  }, {
    key: "controls",
    get: function get() {
      return this.getAttribute('controls');
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.popUp = document.querySelector('.video-popup-container');
      this.popUpVideo = this.popUp.querySelector('.video-container'); // video inside of popup

      this.openButton = this.querySelector('.ed-video-opener'); //this.playButton = this.querySelector('.play-btn'); // OPTIONAL SECOND BUTTON

      this.closeButton = this.popUp.querySelector('.btn-close');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      document.addEventListener('keydown', this.closeOnEsc.bind(this));
      this.openButton.addEventListener('click', this.openPopup.bind(this)); //this.playButton.addEventListener('click', this.openPopup.bind(this));
      // click outside
      //this.popUp.addEventListener('click', this.closePopup.bind(this)); -> NEEDS A BUGIF AS CONTROLS ARE CLOSING THE VIDEO

      this.closeButton.addEventListener('click', this.closePopup.bind(this));
    }
  }, {
    key: "openPopup",
    value: function openPopup(e) {
      e.stopPropagation();
      this.createVideo();
      this.popUp.classList.add('open');
      document.documentElement.classList.add('ed-video-popup-open');
    }
  }, {
    key: "closePopup",
    value: function closePopup(e) {
      e.stopPropagation();
      this.popUpVideo.innerHTML = '';
      this.popUp.classList.remove('open');
      document.documentElement.classList.remove('ed-video-popup-open');
    }
  }, {
    key: "closeOnEsc",
    value: function closeOnEsc(e) {
      if (e.key === 'Escape') {
        this.popUpVideo.innerHTML = '';
        document.documentElement.classList.remove('ed-video-popup-open');
        this.popUp.classList.remove('open');
      }
    }
  }, {
    key: "createVideo",
    value: function createVideo() {
      var video = document.createElement('video');
      video.src = this.videoSrc;
      /** settings **/

      video.autoplay = true;
      video.controls = true;

      if (this.autoPlay === 'false') {
        video.autoplay = false;
      }

      if (this.controls === 'false') {
        video.controls = false;
      }

      this.popUpVideo.appendChild(video);
    }
  }]);

  return EdVideoThumbnail;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

customElements.define('ed-video-thumbnail', EdVideoThumbnail);

var EdVideoPopup = /*#__PURE__*/function (_HTMLElement2) {
  _inherits(EdVideoPopup, _HTMLElement2);

  var _super2 = _createSuper(EdVideoPopup);

  function EdVideoPopup() {
    _classCallCheck(this, EdVideoPopup);

    return _super2.call(this);
  }

  return _createClass(EdVideoPopup);
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

customElements.define('ed-video-popup', EdVideoPopup);

/***/ }),

/***/ "./src/js/modules/ed-warranty-modal.js":
/*!*********************************************!*\
  !*** ./src/js/modules/ed-warranty-modal.js ***!
  \*********************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var OPEN_CLASS = 'is-open';
var DRAGGING_CLASS = 'is-dragging';
var SCROLL_LOCK_CLASS = 'ed-warranty-modal-lock';
var CLOSE_ANIMATION_FALLBACK_MS = 400;
var CLOSE_DRAG_THRESHOLD_PX = 100;

var EdWarrantyModal = /*#__PURE__*/function (_HTMLElement) {
  _inherits(EdWarrantyModal, _HTMLElement);

  var _super = _createSuper(EdWarrantyModal);

  function EdWarrantyModal() {
    _classCallCheck(this, EdWarrantyModal);

    return _super.apply(this, arguments);
  }

  _createClass(EdWarrantyModal, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();

      this._attachListeners();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.dialog = this.querySelector('[data-warranty-dialog]');
      this.image = this.querySelector('[data-src]');
      this.closeBtn = this.querySelector('[data-warranty-close]');
      this.handle = this.querySelector('[data-warranty-handle]');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      document.addEventListener('click', this.handleTriggerClick.bind(this));
      window.addEventListener('keyup', this.handleEscapeKeyup.bind(this), true);
      this.closeBtn.addEventListener('click', this.close.bind(this));
      this.dialog.addEventListener('click', this.handleBackdropClick.bind(this));
      this.dialog.addEventListener('cancel', this.handleCancel.bind(this));
      this.handle.addEventListener('touchstart', this.handleDragStart.bind(this), {
        passive: true
      });
      this.handle.addEventListener('touchmove', this.handleDragMove.bind(this), {
        passive: true
      });
      this.handle.addEventListener('touchend', this.handleDragEnd.bind(this));
    }
  }, {
    key: "handleTriggerClick",
    value: function handleTriggerClick(event) {
      var trigger = event.target.closest('[data-warranty-open]');
      var supportsDialog = typeof this.dialog.showModal === 'function';
      if (!trigger || !supportsDialog) return;
      event.preventDefault();
      this.open();
    }
  }, {
    key: "open",
    value: function open() {
      var _this = this;

      if (this.dialog.open) return;

      this._loadImage();

      this.dialog.showModal();
      document.documentElement.classList.add(SCROLL_LOCK_CLASS);
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          return _this.dialog.classList.add(OPEN_CLASS);
        });
      });
    }
  }, {
    key: "close",
    value: function close() {
      var _this2 = this;

      if (!this.dialog.open || this.isClosing) return;
      this.isClosing = true;
      this.dialog.style.transform = '';
      this.dialog.classList.remove(OPEN_CLASS);
      this._onCloseAnimationEnd = this._onCloseAnimationEnd || this.handleCloseAnimationEnd.bind(this);
      this.dialog.addEventListener('transitionend', this._onCloseAnimationEnd);
      this.closeFallbackTimer = setTimeout(function () {
        return _this2._finishClose();
      }, CLOSE_ANIMATION_FALLBACK_MS);
    }
  }, {
    key: "handleCloseAnimationEnd",
    value: function handleCloseAnimationEnd(event) {
      if (event.target !== this.dialog) return;

      this._finishClose();
    }
  }, {
    key: "_finishClose",
    value: function _finishClose() {
      clearTimeout(this.closeFallbackTimer);
      this.dialog.removeEventListener('transitionend', this._onCloseAnimationEnd);
      this.dialog.close();
      document.documentElement.classList.remove(SCROLL_LOCK_CLASS);
      this.isClosing = false;
    }
  }, {
    key: "_loadImage",
    value: function _loadImage() {
      if (this.image.src) return;
      this.image.src = this.image.dataset.src;
    }
  }, {
    key: "handleCancel",
    value: function handleCancel(event) {
      event.preventDefault();
      this.swallowNextEscapeKeyup = true;
      this.close();
    }
  }, {
    key: "handleEscapeKeyup",
    value: function handleEscapeKeyup(event) {
      if (event.key !== 'Escape' || !this.swallowNextEscapeKeyup) return;
      this.swallowNextEscapeKeyup = false;
      event.stopImmediatePropagation();
    }
  }, {
    key: "handleBackdropClick",
    value: function handleBackdropClick(event) {
      if (event.target !== this.dialog) return;
      this.close();
    }
  }, {
    key: "handleDragStart",
    value: function handleDragStart(event) {
      this.dragStartY = event.touches[0].clientY;
      this.dragOffset = 0;
      this.dialog.classList.add(DRAGGING_CLASS);
    }
  }, {
    key: "handleDragMove",
    value: function handleDragMove(event) {
      if (this.dragStartY === undefined) return;
      this.dragOffset = Math.max(0, event.touches[0].clientY - this.dragStartY);
      this.dialog.style.transform = "translateY(".concat(this.dragOffset, "px)");
    }
  }, {
    key: "handleDragEnd",
    value: function handleDragEnd() {
      var shouldClose = this.dragOffset > CLOSE_DRAG_THRESHOLD_PX;
      this.dragStartY = undefined;
      this.dialog.classList.remove(DRAGGING_CLASS);

      if (shouldClose) {
        this.close();
      } else {
        this.dialog.style.transform = '';
      }
    }
  }]);

  return EdWarrantyModal;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

if (!customElements.get('ed-warranty-modal')) {
  customElements.define('ed-warranty-modal', EdWarrantyModal);
}

/***/ }),

/***/ "./node_modules/@glidejs/glide/dist/css/glide.core.min.css":
/*!*****************************************************************!*\
  !*** ./node_modules/@glidejs/glide/dist/css/glide.core.min.css ***!
  \*****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./node_modules/@glidejs/glide/dist/glide.esm.js":
/*!*******************************************************!*\
  !*** ./node_modules/@glidejs/glide/dist/glide.esm.js ***!
  \*******************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Glide)
/* harmony export */ });
function _typeof2(obj) { "@babel/helpers - typeof"; return _typeof2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof2(obj); }

/*!
 * Glide.js v3.7.1
 * (c) 2013-2024 Jędrzej Chałubek (https://github.com/jedrzejchalubek/)
 * Released under the MIT License.
 */
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof2(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _superPropBase(object, property) {
  while (!Object.prototype.hasOwnProperty.call(object, property)) {
    object = _getPrototypeOf(object);
    if (object === null) break;
  }

  return object;
}

function _get() {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get = Reflect.get;
  } else {
    _get = function _get(target, property, receiver) {
      var base = _superPropBase(target, property);

      if (!base) return;
      var desc = Object.getOwnPropertyDescriptor(base, property);

      if (desc.get) {
        return desc.get.call(arguments.length < 3 ? target : receiver);
      }

      return desc.value;
    };
  }

  return _get.apply(this, arguments);
}

var defaults = {
  /**
   * Type of the movement.
   *
   * Available types:
   * `slider` - Rewinds slider to the start/end when it reaches the first or last slide.
   * `carousel` - Changes slides without starting over when it reaches the first or last slide.
   *
   * @type {String}
   */
  type: 'slider',

  /**
   * Start at specific slide number defined with zero-based index.
   *
   * @type {Number}
   */
  startAt: 0,

  /**
   * A number of slides visible on the single viewport.
   *
   * @type {Number}
   */
  perView: 1,

  /**
   * Focus currently active slide at a specified position in the track.
   *
   * Available inputs:
   * `center` - Current slide will be always focused at the center of a track.
   * `0,1,2,3...` - Current slide will be focused on the specified zero-based index.
   *
   * @type {String|Number}
   */
  focusAt: 0,

  /**
   * A size of the gap added between slides.
   *
   * @type {Number}
   */
  gap: 10,

  /**
   * Change slides after a specified interval. Use `false` for turning off autoplay.
   *
   * @type {Number|Boolean}
   */
  autoplay: false,

  /**
   * Stop autoplay on mouseover event.
   *
   * @type {Boolean}
   */
  hoverpause: true,

  /**
   * Allow for changing slides with left and right keyboard arrows.
   *
   * @type {Boolean}
   */
  keyboard: true,

  /**
   * Stop running `perView` number of slides from the end. Use this
   * option if you don't want to have an empty space after
   * a slider. Works only with `slider` type and a
   * non-centered `focusAt` setting.
   *
   * @type {Boolean}
   */
  bound: false,

  /**
   * Minimal swipe distance needed to change the slide. Use `false` for turning off a swiping.
   *
   * @type {Number|Boolean}
   */
  swipeThreshold: 80,

  /**
   * Minimal mouse drag distance needed to change the slide. Use `false` for turning off a dragging.
   *
   * @type {Number|Boolean}
   */
  dragThreshold: 120,

  /**
   * A number of slides moved on single swipe.
   *
   * Available types:
   * `` - Moves slider by one slide per swipe
   * `|` - Moves slider between views per swipe (number of slides defined in `perView` options)
   *
   * @type {String}
   */
  perSwipe: '',

  /**
   * Moving distance ratio of the slides on a swiping and dragging.
   *
   * @type {Number}
   */
  touchRatio: 0.5,

  /**
   * Angle required to activate slides moving on swiping or dragging.
   *
   * @type {Number}
   */
  touchAngle: 45,

  /**
   * Duration of the animation in milliseconds.
   *
   * @type {Number}
   */
  animationDuration: 400,

  /**
   * Allows looping the `slider` type. Slider will rewind to the first/last slide when it's at the start/end.
   *
   * @type {Boolean}
   */
  rewind: true,

  /**
   * Duration of the rewinding animation of the `slider` type in milliseconds.
   *
   * @type {Number}
   */
  rewindDuration: 800,

  /**
   * Easing function for the animation.
   *
   * @type {String}
   */
  animationTimingFunc: 'cubic-bezier(.165, .840, .440, 1)',

  /**
   * Wait for the animation to finish until the next user input can be processed
   *
   * @type {boolean}
   */
  waitForTransition: true,

  /**
   * Throttle costly events at most once per every wait milliseconds.
   *
   * @type {Number}
   */
  throttle: 10,

  /**
   * Moving direction mode.
   *
   * Available inputs:
   * - 'ltr' - left to right movement,
   * - 'rtl' - right to left movement.
   *
   * @type {String}
   */
  direction: 'ltr',

  /**
   * The distance value of the next and previous viewports which
   * have to peek in the current view. Accepts number and
   * pixels as a string. Left and right peeking can be
   * set up separately with a directions object.
   *
   * For example:
   * `100` - Peek 100px on the both sides.
   * { before: 100, after: 50 }` - Peek 100px on the left side and 50px on the right side.
   *
   * @type {Number|String|Object}
   */
  peek: 0,

  /**
   * Defines how many clones of current viewport will be generated.
   *
   * @type {Number}
   */
  cloningRatio: 1,

  /**
   * Collection of options applied at specified media breakpoints.
   * For example: display two slides per view under 800px.
   * `{
   *   '800px': {
   *     perView: 2
   *   }
   * }`
   */
  breakpoints: {},

  /**
   * Collection of internally used HTML classes.
   *
   * @todo Refactor `slider` and `carousel` properties to single `type: { slider: '', carousel: '' }` object
   * @type {Object}
   */
  classes: {
    swipeable: 'glide--swipeable',
    dragging: 'glide--dragging',
    direction: {
      ltr: 'glide--ltr',
      rtl: 'glide--rtl'
    },
    type: {
      slider: 'glide--slider',
      carousel: 'glide--carousel'
    },
    slide: {
      clone: 'glide__slide--clone',
      active: 'glide__slide--active'
    },
    arrow: {
      disabled: 'glide__arrow--disabled'
    },
    nav: {
      active: 'glide__bullet--active'
    }
  }
};
/**
 * Outputs warning message to the bowser console.
 *
 * @param  {String} msg
 * @return {Void}
 */

function warn(msg) {
  console.error("[Glide warn]: ".concat(msg));
}
/**
 * Converts value entered as number
 * or string to integer value.
 *
 * @param {String} value
 * @returns {Number}
 */


function toInt(value) {
  return parseInt(value);
}
/**
 * Converts value entered as number
 * or string to flat value.
 *
 * @param {String} value
 * @returns {Number}
 */


function toFloat(value) {
  return parseFloat(value);
}
/**
 * Indicates whether the specified value is a string.
 *
 * @param  {*}   value
 * @return {Boolean}
 */


function isString(value) {
  return typeof value === 'string';
}
/**
 * Indicates whether the specified value is an object.
 *
 * @param  {*} value
 * @return {Boolean}
 *
 * @see https://github.com/jashkenas/underscore
 */


function isObject(value) {
  var type = _typeof(value);

  return type === 'function' || type === 'object' && !!value; // eslint-disable-line no-mixed-operators
}
/**
 * Indicates whether the specified value is a function.
 *
 * @param  {*} value
 * @return {Boolean}
 */


function isFunction(value) {
  return typeof value === 'function';
}
/**
 * Indicates whether the specified value is undefined.
 *
 * @param  {*} value
 * @return {Boolean}
 */


function isUndefined(value) {
  return typeof value === 'undefined';
}
/**
 * Indicates whether the specified value is an array.
 *
 * @param  {*} value
 * @return {Boolean}
 */


function isArray(value) {
  return value.constructor === Array;
}
/**
 * Creates and initializes specified collection of extensions.
 * Each extension receives access to instance of glide and rest of components.
 *
 * @param {Object} glide
 * @param {Object} extensions
 *
 * @returns {Object}
 */


function mount(glide, extensions, events) {
  var components = {};

  for (var name in extensions) {
    if (isFunction(extensions[name])) {
      components[name] = extensions[name](glide, components, events);
    } else {
      warn('Extension must be a function');
    }
  }

  for (var _name in components) {
    if (isFunction(components[_name].mount)) {
      components[_name].mount();
    }
  }

  return components;
}
/**
 * Defines getter and setter property on the specified object.
 *
 * @param  {Object} obj         Object where property has to be defined.
 * @param  {String} prop        Name of the defined property.
 * @param  {Object} definition  Get and set definitions for the property.
 * @return {Void}
 */


function define(obj, prop, definition) {
  Object.defineProperty(obj, prop, definition);
}
/**
 * Sorts aphabetically object keys.
 *
 * @param  {Object} obj
 * @return {Object}
 */


function sortKeys(obj) {
  return Object.keys(obj).sort().reduce(function (r, k) {
    r[k] = obj[k];
    return r[k], r;
  }, {});
}
/**
 * Merges passed settings object with default options.
 *
 * @param  {Object} defaults
 * @param  {Object} settings
 * @return {Object}
 */


function mergeOptions(defaults, settings) {
  var options = Object.assign({}, defaults, settings); // `Object.assign` do not deeply merge objects, so we
  // have to do it manually for every nested object
  // in options. Although it does not look smart,
  // it's smaller and faster than some fancy
  // merging deep-merge algorithm script.

  if (settings.hasOwnProperty('classes')) {
    options.classes = Object.assign({}, defaults.classes, settings.classes);
    var properties = ['direction', 'type', 'slide', 'arrow', 'nav'];
    properties.forEach(function (property) {
      if (settings.classes.hasOwnProperty(property)) {
        options.classes[property] = _objectSpread2(_objectSpread2({}, defaults.classes[property]), settings.classes[property]);
      }
    });
  }

  if (settings.hasOwnProperty('breakpoints')) {
    options.breakpoints = Object.assign({}, defaults.breakpoints, settings.breakpoints);
  }

  return options;
}

var EventsBus = /*#__PURE__*/function () {
  /**
   * Construct a EventBus instance.
   *
   * @param {Object} events
   */
  function EventsBus() {
    var events = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, EventsBus);

    this.events = events;
    this.hop = events.hasOwnProperty;
  }
  /**
   * Adds listener to the specifed event.
   *
   * @param {String|Array} event
   * @param {Function} handler
   */


  _createClass(EventsBus, [{
    key: "on",
    value: function on(event, handler) {
      if (isArray(event)) {
        for (var i = 0; i < event.length; i++) {
          this.on(event[i], handler);
        }

        return;
      } // Create the event's object if not yet created


      if (!this.hop.call(this.events, event)) {
        this.events[event] = [];
      } // Add the handler to queue


      var index = this.events[event].push(handler) - 1; // Provide handle back for removal of event

      return {
        remove: function remove() {
          delete this.events[event][index];
        }
      };
    }
    /**
     * Runs registered handlers for specified event.
     *
     * @param {String|Array} event
     * @param {Object=} context
     */

  }, {
    key: "emit",
    value: function emit(event, context) {
      if (isArray(event)) {
        for (var i = 0; i < event.length; i++) {
          this.emit(event[i], context);
        }

        return;
      } // If the event doesn't exist, or there's no handlers in queue, just leave


      if (!this.hop.call(this.events, event)) {
        return;
      } // Cycle through events queue, fire!


      this.events[event].forEach(function (item) {
        item(context || {});
      });
    }
  }]);

  return EventsBus;
}();

var Glide$1 = /*#__PURE__*/function () {
  /**
   * Construct glide.
   *
   * @param  {String} selector
   * @param  {Object} options
   */
  function Glide(selector) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Glide);

    this._c = {};
    this._t = [];
    this._e = new EventsBus();
    this.disabled = false;
    this.selector = selector;
    this.settings = mergeOptions(defaults, options);
    this.index = this.settings.startAt;
  }
  /**
   * Initializes glide.
   *
   * @param {Object} extensions Collection of extensions to initialize.
   * @return {Glide}
   */


  _createClass(Glide, [{
    key: "mount",
    value: function mount$1() {
      var extensions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this._e.emit('mount.before');

      if (isObject(extensions)) {
        this._c = mount(this, extensions, this._e);
      } else {
        warn('You need to provide a object on `mount()`');
      }

      this._e.emit('mount.after');

      return this;
    }
    /**
     * Collects an instance `translate` transformers.
     *
     * @param  {Array} transformers Collection of transformers.
     * @return {Void}
     */

  }, {
    key: "mutate",
    value: function mutate() {
      var transformers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      if (isArray(transformers)) {
        this._t = transformers;
      } else {
        warn('You need to provide a array on `mutate()`');
      }

      return this;
    }
    /**
     * Updates glide with specified settings.
     *
     * @param {Object} settings
     * @return {Glide}
     */

  }, {
    key: "update",
    value: function update() {
      var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.settings = mergeOptions(this.settings, settings);

      if (settings.hasOwnProperty('startAt')) {
        this.index = settings.startAt;
      }

      this._e.emit('update');

      return this;
    }
    /**
     * Change slide with specified pattern. A pattern must be in the special format:
     * `>` - Move one forward
     * `<` - Move one backward
     * `={i}` - Go to {i} zero-based slide (eq. '=1', will go to second slide)
     * `>>` - Rewinds to end (last slide)
     * `<<` - Rewinds to start (first slide)
     * `|>` - Move one viewport forward
     * `|<` - Move one viewport backward
     *
     * @param {String} pattern
     * @return {Glide}
     */

  }, {
    key: "go",
    value: function go(pattern) {
      this._c.Run.make(pattern);

      return this;
    }
    /**
     * Move track by specified distance.
     *
     * @param {String} distance
     * @return {Glide}
     */

  }, {
    key: "move",
    value: function move(distance) {
      this._c.Transition.disable();

      this._c.Move.make(distance);

      return this;
    }
    /**
     * Destroy instance and revert all changes done by this._c.
     *
     * @return {Glide}
     */

  }, {
    key: "destroy",
    value: function destroy() {
      this._e.emit('destroy');

      return this;
    }
    /**
     * Start instance autoplaying.
     *
     * @param {Boolean|Number} interval Run autoplaying with passed interval regardless of `autoplay` settings
     * @return {Glide}
     */

  }, {
    key: "play",
    value: function play() {
      var interval = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (interval) {
        this.settings.autoplay = interval;
      }

      this._e.emit('play');

      return this;
    }
    /**
     * Stop instance autoplaying.
     *
     * @return {Glide}
     */

  }, {
    key: "pause",
    value: function pause() {
      this._e.emit('pause');

      return this;
    }
    /**
     * Sets glide into a idle status.
     *
     * @return {Glide}
     */

  }, {
    key: "disable",
    value: function disable() {
      this.disabled = true;
      return this;
    }
    /**
     * Sets glide into a active status.
     *
     * @return {Glide}
     */

  }, {
    key: "enable",
    value: function enable() {
      this.disabled = false;
      return this;
    }
    /**
     * Adds cuutom event listener with handler.
     *
     * @param  {String|Array} event
     * @param  {Function} handler
     * @return {Glide}
     */

  }, {
    key: "on",
    value: function on(event, handler) {
      this._e.on(event, handler);

      return this;
    }
    /**
     * Checks if glide is a precised type.
     *
     * @param  {String} name
     * @return {Boolean}
     */

  }, {
    key: "isType",
    value: function isType(name) {
      return this.settings.type === name;
    }
    /**
     * Gets value of the core options.
     *
     * @return {Object}
     */

  }, {
    key: "settings",
    get: function get() {
      return this._o;
    }
    /**
     * Sets value of the core options.
     *
     * @param  {Object} o
     * @return {Void}
     */
    ,
    set: function set(o) {
      if (isObject(o)) {
        this._o = o;
      } else {
        warn('Options must be an `object` instance.');
      }
    }
    /**
     * Gets current index of the slider.
     *
     * @return {Object}
     */

  }, {
    key: "index",
    get: function get() {
      return this._i;
    }
    /**
     * Sets current index a slider.
     *
     * @return {Object}
     */
    ,
    set: function set(i) {
      this._i = toInt(i);
    }
    /**
     * Gets type name of the slider.
     *
     * @return {String}
     */

  }, {
    key: "type",
    get: function get() {
      return this.settings.type;
    }
    /**
     * Gets value of the idle status.
     *
     * @return {Boolean}
     */

  }, {
    key: "disabled",
    get: function get() {
      return this._d;
    }
    /**
     * Sets value of the idle status.
     *
     * @return {Boolean}
     */
    ,
    set: function set(status) {
      this._d = !!status;
    }
  }]);

  return Glide;
}();

function Run(Glide, Components, Events) {
  var Run = {
    /**
     * Initializes autorunning of the glide.
     *
     * @return {Void}
     */
    mount: function mount() {
      this._o = false;
    },

    /**
     * Makes glides running based on the passed moving schema.
     *
     * @param {String} move
     */
    make: function make(move) {
      var _this = this;

      if (!Glide.disabled) {
        !Glide.settings.waitForTransition || Glide.disable();
        this.move = move;
        Events.emit('run.before', this.move);
        this.calculate();
        Events.emit('run', this.move);
        Components.Transition.after(function () {
          if (_this.isStart()) {
            Events.emit('run.start', _this.move);
          }

          if (_this.isEnd()) {
            Events.emit('run.end', _this.move);
          }

          if (_this.isOffset()) {
            _this._o = false;
            Events.emit('run.offset', _this.move);
          }

          Events.emit('run.after', _this.move);
          Glide.enable();
        });
      }
    },

    /**
     * Calculates current index based on defined move.
     *
     * @return {Number|Undefined}
     */
    calculate: function calculate() {
      var move = this.move,
          length = this.length;
      var steps = move.steps,
          direction = move.direction; // By default assume that size of view is equal to one slide

      var viewSize = 1; // While direction is `=` we want jump to
      // a specified index described in steps.

      if (direction === '=') {
        // Check if bound is true, 
        // as we want to avoid whitespaces.
        if (Glide.settings.bound && toInt(steps) > length) {
          Glide.index = length;
          return;
        }

        Glide.index = steps;
        return;
      } // When pattern is equal to `>>` we want
      // fast forward to the last slide.


      if (direction === '>' && steps === '>') {
        Glide.index = length;
        return;
      } // When pattern is equal to `<<` we want
      // fast forward to the first slide.


      if (direction === '<' && steps === '<') {
        Glide.index = 0;
        return;
      } // pagination movement


      if (direction === '|') {
        viewSize = Glide.settings.perView || 1;
      } // we are moving forward


      if (direction === '>' || direction === '|' && steps === '>') {
        var index = calculateForwardIndex(viewSize);

        if (index > length) {
          this._o = true;
        }

        Glide.index = normalizeForwardIndex(index, viewSize);
        return;
      } // we are moving backward


      if (direction === '<' || direction === '|' && steps === '<') {
        var _index = calculateBackwardIndex(viewSize);

        if (_index < 0) {
          this._o = true;
        }

        Glide.index = normalizeBackwardIndex(_index, viewSize);
        return;
      }

      warn("Invalid direction pattern [".concat(direction).concat(steps, "] has been used"));
    },

    /**
     * Checks if we are on the first slide.
     *
     * @return {Boolean}
     */
    isStart: function isStart() {
      return Glide.index <= 0;
    },

    /**
     * Checks if we are on the last slide.
     *
     * @return {Boolean}
     */
    isEnd: function isEnd() {
      return Glide.index >= this.length;
    },

    /**
     * Checks if we are making a offset run.
     *
     * @param {String} direction
     * @return {Boolean}
     */
    isOffset: function isOffset() {
      var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

      if (!direction) {
        return this._o;
      }

      if (!this._o) {
        return false;
      } // did we view to the right?


      if (direction === '|>') {
        return this.move.direction === '|' && this.move.steps === '>';
      } // did we view to the left?


      if (direction === '|<') {
        return this.move.direction === '|' && this.move.steps === '<';
      }

      return this.move.direction === direction;
    },

    /**
     * Checks if bound mode is active
     *
     * @return {Boolean}
     */
    isBound: function isBound() {
      return Glide.isType('slider') && Glide.settings.focusAt !== 'center' && Glide.settings.bound;
    }
  };
  /**
   * Returns index value to move forward/to the right
   *
   * @param viewSize
   * @returns {Number}
   */

  function calculateForwardIndex(viewSize) {
    var index = Glide.index;

    if (Glide.isType('carousel')) {
      return index + viewSize;
    }

    return index + (viewSize - index % viewSize);
  }
  /**
   * Normalizes the given forward index based on glide settings, preventing it to exceed certain boundaries
   *
   * @param index
   * @param length
   * @param viewSize
   * @returns {Number}
   */


  function normalizeForwardIndex(index, viewSize) {
    var length = Run.length;

    if (index <= length) {
      return index;
    }

    if (Glide.isType('carousel')) {
      return index - (length + 1);
    }

    if (Glide.settings.rewind) {
      // bound does funny things with the length, therefor we have to be certain
      // that we are on the last possible index value given by bound
      if (Run.isBound() && !Run.isEnd()) {
        return length;
      }

      return 0;
    }

    if (Run.isBound()) {
      return length;
    }

    return Math.floor(length / viewSize) * viewSize;
  }
  /**
   * Calculates index value to move backward/to the left
   *
   * @param viewSize
   * @returns {Number}
   */


  function calculateBackwardIndex(viewSize) {
    var index = Glide.index;

    if (Glide.isType('carousel')) {
      return index - viewSize;
    } // ensure our back navigation results in the same index as a forward navigation
    // to experience a homogeneous paging


    var view = Math.ceil(index / viewSize);
    return (view - 1) * viewSize;
  }
  /**
   * Normalizes the given backward index based on glide settings, preventing it to exceed certain boundaries
   *
   * @param index
   * @param length
   * @param viewSize
   * @returns {*}
   */


  function normalizeBackwardIndex(index, viewSize) {
    var length = Run.length;

    if (index >= 0) {
      return index;
    }

    if (Glide.isType('carousel')) {
      return index + (length + 1);
    }

    if (Glide.settings.rewind) {
      // bound does funny things with the length, therefor we have to be certain
      // that we are on first possible index value before we to rewind to the length given by bound
      if (Run.isBound() && Run.isStart()) {
        return length;
      }

      return Math.floor(length / viewSize) * viewSize;
    }

    return 0;
  }

  define(Run, 'move', {
    /**
     * Gets value of the move schema.
     *
     * @returns {Object}
     */
    get: function get() {
      return this._m;
    },

    /**
     * Sets value of the move schema.
     *
     * @returns {Object}
     */
    set: function set(value) {
      var step = value.substr(1);
      this._m = {
        direction: value.substr(0, 1),
        steps: step ? toInt(step) ? toInt(step) : step : 0
      };
    }
  });
  define(Run, 'length', {
    /**
     * Gets value of the running distance based
     * on zero-indexing number of slides.
     *
     * @return {Number}
     */
    get: function get() {
      var settings = Glide.settings;
      var length = Components.Html.slides.length; // If the `bound` option is active, a maximum running distance should be
      // reduced by `perView` and `focusAt` settings. Running distance
      // should end before creating an empty space after instance.

      if (this.isBound()) {
        return length - 1 - (toInt(settings.perView) - 1) + toInt(settings.focusAt);
      }

      return length - 1;
    }
  });
  define(Run, 'offset', {
    /**
     * Gets status of the offsetting flag.
     *
     * @return {Boolean}
     */
    get: function get() {
      return this._o;
    }
  });
  return Run;
}
/**
 * Returns a current time.
 *
 * @return {Number}
 */


function now() {
  return new Date().getTime();
}
/**
 * Returns a function, that, when invoked, will only be triggered
 * at most once during a given window of time.
 *
 * @param {Function} func
 * @param {Number} wait
 * @param {Object=} options
 * @return {Function}
 *
 * @see https://github.com/jashkenas/underscore
 */


function throttle(func, wait) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var timeout, context, args, result;
  var previous = 0;

  var later = function later() {
    previous = options.leading === false ? 0 : now();
    timeout = null;
    result = func.apply(context, args);
    if (!timeout) context = args = null;
  };

  var throttled = function throttled() {
    var at = now();
    if (!previous && options.leading === false) previous = at;
    var remaining = wait - (at - previous);
    context = this;
    args = arguments;

    if (remaining <= 0 || remaining > wait) {
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }

      previous = at;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    } else if (!timeout && options.trailing !== false) {
      timeout = setTimeout(later, remaining);
    }

    return result;
  };

  throttled.cancel = function () {
    clearTimeout(timeout);
    previous = 0;
    timeout = context = args = null;
  };

  return throttled;
}

var MARGIN_TYPE = {
  ltr: ['marginLeft', 'marginRight'],
  rtl: ['marginRight', 'marginLeft']
};

function Gaps(Glide, Components, Events) {
  var Gaps = {
    /**
     * Applies gaps between slides. First and last
     * slides do not receive it's edge margins.
     *
     * @param {HTMLCollection} slides
     * @return {Void}
     */
    apply: function apply(slides) {
      for (var i = 0, len = slides.length; i < len; i++) {
        var style = slides[i].style;
        var direction = Components.Direction.value;

        if (i !== 0) {
          style[MARGIN_TYPE[direction][0]] = "".concat(this.value / 2, "px");
        } else {
          style[MARGIN_TYPE[direction][0]] = '';
        }

        if (i !== slides.length - 1) {
          style[MARGIN_TYPE[direction][1]] = "".concat(this.value / 2, "px");
        } else {
          style[MARGIN_TYPE[direction][1]] = '';
        }
      }
    },

    /**
     * Removes gaps from the slides.
     *
     * @param {HTMLCollection} slides
     * @returns {Void}
    */
    remove: function remove(slides) {
      for (var i = 0, len = slides.length; i < len; i++) {
        var style = slides[i].style;
        style.marginLeft = '';
        style.marginRight = '';
      }
    }
  };
  define(Gaps, 'value', {
    /**
     * Gets value of the gap.
     *
     * @returns {Number}
     */
    get: function get() {
      return toInt(Glide.settings.gap);
    }
  });
  define(Gaps, 'grow', {
    /**
     * Gets additional dimensions value caused by gaps.
     * Used to increase width of the slides wrapper.
     *
     * @returns {Number}
     */
    get: function get() {
      return Gaps.value * Components.Sizes.length;
    }
  });
  define(Gaps, 'reductor', {
    /**
     * Gets reduction value caused by gaps.
     * Used to subtract width of the slides.
     *
     * @returns {Number}
     */
    get: function get() {
      var perView = Glide.settings.perView;
      return Gaps.value * (perView - 1) / perView;
    }
  });
  /**
   * Apply calculated gaps:
   * - after building, so slides (including clones) will receive proper margins
   * - on updating via API, to recalculate gaps with new options
   */

  Events.on(['build.after', 'update'], throttle(function () {
    Gaps.apply(Components.Html.wrapper.children);
  }, 30));
  /**
   * Remove gaps:
   * - on destroying to bring markup to its inital state
   */

  Events.on('destroy', function () {
    Gaps.remove(Components.Html.wrapper.children);
  });
  return Gaps;
}
/**
 * Finds siblings nodes of the passed node.
 *
 * @param  {Element} node
 * @return {Array}
 */


function siblings(node) {
  if (node && node.parentNode) {
    var n = node.parentNode.firstChild;
    var matched = [];

    for (; n; n = n.nextSibling) {
      if (n.nodeType === 1 && n !== node) {
        matched.push(n);
      }
    }

    return matched;
  }

  return [];
}
/**
 * Coerces a NodeList to an Array.
 *
 * @param  {NodeList} nodeList
 * @return {Array}
 */


function toArray(nodeList) {
  return Array.prototype.slice.call(nodeList);
}

var TRACK_SELECTOR = '[data-glide-el="track"]';

function Html(Glide, Components, Events) {
  var Html = {
    /**
     * Setup slider HTML nodes.
     *
     * @param {Glide} glide
     */
    mount: function mount() {
      this.root = Glide.selector;
      this.track = this.root.querySelector(TRACK_SELECTOR);
      this.collectSlides();
    },

    /**
     * Collect slides
     */
    collectSlides: function collectSlides() {
      this.slides = toArray(this.wrapper.children).filter(function (slide) {
        return !slide.classList.contains(Glide.settings.classes.slide.clone);
      });
    }
  };
  define(Html, 'root', {
    /**
     * Gets node of the glide main element.
     *
     * @return {Object}
     */
    get: function get() {
      return Html._r;
    },

    /**
     * Sets node of the glide main element.
     *
     * @return {Object}
     */
    set: function set(r) {
      if (isString(r)) {
        r = document.querySelector(r);
      }

      if (r !== null) {
        Html._r = r;
      } else {
        warn('Root element must be a existing Html node');
      }
    }
  });
  define(Html, 'track', {
    /**
     * Gets node of the glide track with slides.
     *
     * @return {Object}
     */
    get: function get() {
      return Html._t;
    },

    /**
     * Sets node of the glide track with slides.
     *
     * @return {Object}
     */
    set: function set(t) {
      Html._t = t;
    }
  });
  define(Html, 'wrapper', {
    /**
     * Gets node of the slides wrapper.
     *
     * @return {Object}
     */
    get: function get() {
      return Html.track.children[0];
    }
  });
  /**
   * Add/remove/reorder dynamic slides
   */

  Events.on('update', function () {
    Html.collectSlides();
  });
  return Html;
}

function Peek(Glide, Components, Events) {
  var Peek = {
    /**
     * Setups how much to peek based on settings.
     *
     * @return {Void}
     */
    mount: function mount() {
      this.value = Glide.settings.peek;
    }
  };
  define(Peek, 'value', {
    /**
     * Gets value of the peek.
     *
     * @returns {Number|Object}
     */
    get: function get() {
      return Peek._v;
    },

    /**
     * Sets value of the peek.
     *
     * @param {Number|Object} value
     * @return {Void}
     */
    set: function set(value) {
      if (isObject(value)) {
        value.before = toInt(value.before);
        value.after = toInt(value.after);
      } else {
        value = toInt(value);
      }

      Peek._v = value;
    }
  });
  define(Peek, 'reductor', {
    /**
     * Gets reduction value caused by peek.
     *
     * @returns {Number}
     */
    get: function get() {
      var value = Peek.value;
      var perView = Glide.settings.perView;

      if (isObject(value)) {
        return value.before / perView + value.after / perView;
      }

      return value * 2 / perView;
    }
  });
  /**
   * Recalculate peeking sizes on:
   * - when resizing window to update to proper percents
   */

  Events.on(['resize', 'update'], function () {
    Peek.mount();
  });
  return Peek;
}

function Move(Glide, Components, Events) {
  var Move = {
    /**
     * Constructs move component.
     *
     * @returns {Void}
     */
    mount: function mount() {
      this._o = 0;
    },

    /**
     * Calculates a movement value based on passed offset and currently active index.
     *
     * @param  {Number} offset
     * @return {Void}
     */
    make: function make() {
      var _this = this;

      var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      this.offset = offset;
      Events.emit('move', {
        movement: this.value
      });
      Components.Transition.after(function () {
        Events.emit('move.after', {
          movement: _this.value
        });
      });
    }
  };
  define(Move, 'offset', {
    /**
     * Gets an offset value used to modify current translate.
     *
     * @return {Object}
     */
    get: function get() {
      return Move._o;
    },

    /**
     * Sets an offset value used to modify current translate.
     *
     * @return {Object}
     */
    set: function set(value) {
      Move._o = !isUndefined(value) ? toInt(value) : 0;
    }
  });
  define(Move, 'translate', {
    /**
     * Gets a raw movement value.
     *
     * @return {Number}
     */
    get: function get() {
      return Components.Sizes.slideWidth * Glide.index;
    }
  });
  define(Move, 'value', {
    /**
     * Gets an actual movement value corrected by offset.
     *
     * @return {Number}
     */
    get: function get() {
      var offset = this.offset;
      var translate = this.translate;

      if (Components.Direction.is('rtl')) {
        return translate + offset;
      }

      return translate - offset;
    }
  });
  /**
   * Make movement to proper slide on:
   * - before build, so glide will start at `startAt` index
   * - on each standard run to move to newly calculated index
   */

  Events.on(['build.before', 'run'], function () {
    Move.make();
  });
  return Move;
}

function Sizes(Glide, Components, Events) {
  var Sizes = {
    /**
     * Setups dimensions of slides.
     *
     * @return {Void}
     */
    setupSlides: function setupSlides() {
      var width = "".concat(this.slideWidth, "px");
      var slides = Components.Html.slides;

      for (var i = 0; i < slides.length; i++) {
        slides[i].style.width = width;
      }
    },

    /**
     * Setups dimensions of slides wrapper.
     *
     * @return {Void}
     */
    setupWrapper: function setupWrapper() {
      Components.Html.wrapper.style.width = "".concat(this.wrapperSize, "px");
    },

    /**
     * Removes applied styles from HTML elements.
     *
     * @returns {Void}
     */
    remove: function remove() {
      var slides = Components.Html.slides;

      for (var i = 0; i < slides.length; i++) {
        slides[i].style.width = '';
      }

      Components.Html.wrapper.style.width = '';
    }
  };
  define(Sizes, 'length', {
    /**
     * Gets count number of the slides.
     *
     * @return {Number}
     */
    get: function get() {
      return Components.Html.slides.length;
    }
  });
  define(Sizes, 'width', {
    /**
     * Gets width value of the slider (visible area).
     *
     * @return {Number}
     */
    get: function get() {
      return Components.Html.track.offsetWidth;
    }
  });
  define(Sizes, 'wrapperSize', {
    /**
     * Gets size of the slides wrapper.
     *
     * @return {Number}
     */
    get: function get() {
      return Sizes.slideWidth * Sizes.length + Components.Gaps.grow + Components.Clones.grow;
    }
  });
  define(Sizes, 'slideWidth', {
    /**
     * Gets width value of a single slide.
     *
     * @return {Number}
     */
    get: function get() {
      return Sizes.width / Glide.settings.perView - Components.Peek.reductor - Components.Gaps.reductor;
    }
  });
  /**
   * Apply calculated glide's dimensions:
   * - before building, so other dimensions (e.g. translate) will be calculated propertly
   * - when resizing window to recalculate sildes dimensions
   * - on updating via API, to calculate dimensions based on new options
   */

  Events.on(['build.before', 'resize', 'update'], function () {
    Sizes.setupSlides();
    Sizes.setupWrapper();
  });
  /**
   * Remove calculated glide's dimensions:
   * - on destoting to bring markup to its inital state
   */

  Events.on('destroy', function () {
    Sizes.remove();
  });
  return Sizes;
}

function Build(Glide, Components, Events) {
  var Build = {
    /**
     * Init glide building. Adds classes, sets
     * dimensions and setups initial state.
     *
     * @return {Void}
     */
    mount: function mount() {
      Events.emit('build.before');
      this.typeClass();
      this.activeClass();
      Events.emit('build.after');
    },

    /**
     * Adds `type` class to the glide element.
     *
     * @return {Void}
     */
    typeClass: function typeClass() {
      Components.Html.root.classList.add(Glide.settings.classes.type[Glide.settings.type]);
    },

    /**
     * Sets active class to current slide.
     *
     * @return {Void}
     */
    activeClass: function activeClass() {
      var classes = Glide.settings.classes;
      var slide = Components.Html.slides[Glide.index];

      if (slide) {
        slide.classList.add(classes.slide.active);
        siblings(slide).forEach(function (sibling) {
          sibling.classList.remove(classes.slide.active);
        });
      }
    },

    /**
     * Removes HTML classes applied at building.
     *
     * @return {Void}
     */
    removeClasses: function removeClasses() {
      var _Glide$settings$class = Glide.settings.classes,
          type = _Glide$settings$class.type,
          slide = _Glide$settings$class.slide;
      Components.Html.root.classList.remove(type[Glide.settings.type]);
      Components.Html.slides.forEach(function (sibling) {
        sibling.classList.remove(slide.active);
      });
    }
  };
  /**
   * Clear building classes:
   * - on destroying to bring HTML to its initial state
   * - on updating to remove classes before remounting component
   */

  Events.on(['destroy', 'update'], function () {
    Build.removeClasses();
  });
  /**
   * Remount component:
   * - on resizing of the window to calculate new dimensions
   * - on updating settings via API
   */

  Events.on(['resize', 'update'], function () {
    Build.mount();
  });
  /**
   * Swap active class of current slide:
   * - after each move to the new index
   */

  Events.on('move.after', function () {
    Build.activeClass();
  });
  return Build;
}

function Clones(Glide, Components, Events) {
  var Clones = {
    /**
     * Create pattern map and collect slides to be cloned.
     */
    mount: function mount() {
      this.items = [];

      if (Glide.isType('carousel')) {
        this.items = this.collect();
      }
    },

    /**
     * Collect clones with pattern.
     *
     * @return {[]}
     */
    collect: function collect() {
      var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var slides = Components.Html.slides;
      var _Glide$settings = Glide.settings,
          perView = _Glide$settings.perView,
          classes = _Glide$settings.classes,
          cloningRatio = _Glide$settings.cloningRatio;

      if (slides.length > 0) {
        var peekIncrementer = +!!Glide.settings.peek;
        var cloneCount = perView + peekIncrementer + Math.round(perView / 2);
        var append = slides.slice(0, cloneCount).reverse();
        var prepend = slides.slice(cloneCount * -1);

        for (var r = 0; r < Math.max(cloningRatio, Math.floor(perView / slides.length)); r++) {
          for (var i = 0; i < append.length; i++) {
            var clone = append[i].cloneNode(true);
            clone.classList.add(classes.slide.clone);
            items.push(clone);
          }

          for (var _i = 0; _i < prepend.length; _i++) {
            var _clone = prepend[_i].cloneNode(true);

            _clone.classList.add(classes.slide.clone);

            items.unshift(_clone);
          }
        }
      }

      return items;
    },

    /**
     * Append cloned slides with generated pattern.
     *
     * @return {Void}
     */
    append: function append() {
      var items = this.items;
      var _Components$Html = Components.Html,
          wrapper = _Components$Html.wrapper,
          slides = _Components$Html.slides;
      var half = Math.floor(items.length / 2);
      var prepend = items.slice(0, half).reverse();
      var append = items.slice(half * -1).reverse();
      var width = "".concat(Components.Sizes.slideWidth, "px");

      for (var i = 0; i < append.length; i++) {
        wrapper.appendChild(append[i]);
      }

      for (var _i2 = 0; _i2 < prepend.length; _i2++) {
        wrapper.insertBefore(prepend[_i2], slides[0]);
      }

      for (var _i3 = 0; _i3 < items.length; _i3++) {
        items[_i3].style.width = width;
      }
    },

    /**
     * Remove all cloned slides.
     *
     * @return {Void}
     */
    remove: function remove() {
      var items = this.items;

      for (var i = 0; i < items.length; i++) {
        Components.Html.wrapper.removeChild(items[i]);
      }
    }
  };
  define(Clones, 'grow', {
    /**
     * Gets additional dimensions value caused by clones.
     *
     * @return {Number}
     */
    get: function get() {
      return (Components.Sizes.slideWidth + Components.Gaps.value) * Clones.items.length;
    }
  });
  /**
   * Append additional slide's clones:
   * - while glide's type is `carousel`
   */

  Events.on('update', function () {
    Clones.remove();
    Clones.mount();
    Clones.append();
  });
  /**
   * Append additional slide's clones:
   * - while glide's type is `carousel`
   */

  Events.on('build.before', function () {
    if (Glide.isType('carousel')) {
      Clones.append();
    }
  });
  /**
   * Remove clones HTMLElements:
   * - on destroying, to bring HTML to its initial state
   */

  Events.on('destroy', function () {
    Clones.remove();
  });
  return Clones;
}

var EventsBinder = /*#__PURE__*/function () {
  /**
   * Construct a EventsBinder instance.
   */
  function EventsBinder() {
    var listeners = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, EventsBinder);

    this.listeners = listeners;
  }
  /**
   * Adds events listeners to arrows HTML elements.
   *
   * @param  {String|Array} events
   * @param  {Element|Window|Document} el
   * @param  {Function} closure
   * @param  {Boolean|Object} capture
   * @return {Void}
   */


  _createClass(EventsBinder, [{
    key: "on",
    value: function on(events, el, closure) {
      var capture = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

      if (isString(events)) {
        events = [events];
      }

      for (var i = 0; i < events.length; i++) {
        this.listeners[events[i]] = closure;
        el.addEventListener(events[i], this.listeners[events[i]], capture);
      }
    }
    /**
     * Removes event listeners from arrows HTML elements.
     *
     * @param  {String|Array} events
     * @param  {Element|Window|Document} el
     * @param  {Boolean|Object} capture
     * @return {Void}
     */

  }, {
    key: "off",
    value: function off(events, el) {
      var capture = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (isString(events)) {
        events = [events];
      }

      for (var i = 0; i < events.length; i++) {
        el.removeEventListener(events[i], this.listeners[events[i]], capture);
      }
    }
    /**
     * Destroy collected listeners.
     *
     * @returns {Void}
     */

  }, {
    key: "destroy",
    value: function destroy() {
      delete this.listeners;
    }
  }]);

  return EventsBinder;
}();

function Resize(Glide, Components, Events) {
  /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */
  var Binder = new EventsBinder();
  var Resize = {
    /**
     * Initializes window bindings.
     */
    mount: function mount() {
      this.bind();
    },

    /**
     * Binds `rezsize` listener to the window.
     * It's a costly event, so we are debouncing it.
     *
     * @return {Void}
     */
    bind: function bind() {
      Binder.on('resize', window, throttle(function () {
        Events.emit('resize');
      }, Glide.settings.throttle));
    },

    /**
     * Unbinds listeners from the window.
     *
     * @return {Void}
     */
    unbind: function unbind() {
      Binder.off('resize', window);
    }
  };
  /**
   * Remove bindings from window:
   * - on destroying, to remove added EventListener
   */

  Events.on('destroy', function () {
    Resize.unbind();
    Binder.destroy();
  });
  return Resize;
}

var VALID_DIRECTIONS = ['ltr', 'rtl'];
var FLIPED_MOVEMENTS = {
  '>': '<',
  '<': '>',
  '=': '='
};

function Direction(Glide, Components, Events) {
  var Direction = {
    /**
     * Setups gap value based on settings.
     *
     * @return {Void}
     */
    mount: function mount() {
      this.value = Glide.settings.direction;
    },

    /**
     * Resolves pattern based on direction value
     *
     * @param {String} pattern
     * @returns {String}
     */
    resolve: function resolve(pattern) {
      var token = pattern.slice(0, 1);

      if (this.is('rtl')) {
        return pattern.split(token).join(FLIPED_MOVEMENTS[token]);
      }

      return pattern;
    },

    /**
     * Checks value of direction mode.
     *
     * @param {String} direction
     * @returns {Boolean}
     */
    is: function is(direction) {
      return this.value === direction;
    },

    /**
     * Applies direction class to the root HTML element.
     *
     * @return {Void}
     */
    addClass: function addClass() {
      Components.Html.root.classList.add(Glide.settings.classes.direction[this.value]);
    },

    /**
     * Removes direction class from the root HTML element.
     *
     * @return {Void}
     */
    removeClass: function removeClass() {
      Components.Html.root.classList.remove(Glide.settings.classes.direction[this.value]);
    }
  };
  define(Direction, 'value', {
    /**
     * Gets value of the direction.
     *
     * @returns {Number}
     */
    get: function get() {
      return Direction._v;
    },

    /**
     * Sets value of the direction.
     *
     * @param {String} value
     * @return {Void}
     */
    set: function set(value) {
      if (VALID_DIRECTIONS.indexOf(value) > -1) {
        Direction._v = value;
      } else {
        warn('Direction value must be `ltr` or `rtl`');
      }
    }
  });
  /**
   * Clear direction class:
   * - on destroy to bring HTML to its initial state
   * - on update to remove class before reappling bellow
   */

  Events.on(['destroy', 'update'], function () {
    Direction.removeClass();
  });
  /**
   * Remount component:
   * - on update to reflect changes in direction value
   */

  Events.on('update', function () {
    Direction.mount();
  });
  /**
   * Apply direction class:
   * - before building to apply class for the first time
   * - on updating to reapply direction class that may changed
   */

  Events.on(['build.before', 'update'], function () {
    Direction.addClass();
  });
  return Direction;
}
/**
 * Reflects value of glide movement.
 *
 * @param  {Object} Glide
 * @param  {Object} Components
 * @return {Object}
 */


function Rtl(Glide, Components) {
  return {
    /**
     * Negates the passed translate if glide is in RTL option.
     *
     * @param  {Number} translate
     * @return {Number}
     */
    modify: function modify(translate) {
      if (Components.Direction.is('rtl')) {
        return -translate;
      }

      return translate;
    }
  };
}
/**
 * Updates glide movement with a `gap` settings.
 *
 * @param  {Object} Glide
 * @param  {Object} Components
 * @return {Object}
 */


function Gap(Glide, Components) {
  return {
    /**
     * Modifies passed translate value with number in the `gap` settings.
     *
     * @param  {Number} translate
     * @return {Number}
     */
    modify: function modify(translate) {
      var multiplier = Math.floor(translate / Components.Sizes.slideWidth);
      return translate + Components.Gaps.value * multiplier;
    }
  };
}
/**
 * Updates glide movement with width of additional clones width.
 *
 * @param  {Object} Glide
 * @param  {Object} Components
 * @return {Object}
 */


function Grow(Glide, Components) {
  return {
    /**
     * Adds to the passed translate width of the half of clones.
     *
     * @param  {Number} translate
     * @return {Number}
     */
    modify: function modify(translate) {
      return translate + Components.Clones.grow / 2;
    }
  };
}
/**
 * Updates glide movement with a `peek` settings.
 *
 * @param  {Object} Glide
 * @param  {Object} Components
 * @return {Object}
 */


function Peeking(Glide, Components) {
  return {
    /**
     * Modifies passed translate value with a `peek` setting.
     *
     * @param  {Number} translate
     * @return {Number}
     */
    modify: function modify(translate) {
      if (Glide.settings.focusAt >= 0) {
        var peek = Components.Peek.value;

        if (isObject(peek)) {
          return translate - peek.before;
        }

        return translate - peek;
      }

      return translate;
    }
  };
}
/**
 * Updates glide movement with a `focusAt` settings.
 *
 * @param  {Object} Glide
 * @param  {Object} Components
 * @return {Object}
 */


function Focusing(Glide, Components) {
  return {
    /**
     * Modifies passed translate value with index in the `focusAt` setting.
     *
     * @param  {Number} translate
     * @return {Number}
     */
    modify: function modify(translate) {
      var gap = Components.Gaps.value;
      var width = Components.Sizes.width;
      var focusAt = Glide.settings.focusAt;
      var slideWidth = Components.Sizes.slideWidth;

      if (focusAt === 'center') {
        return translate - (width / 2 - slideWidth / 2);
      }

      return translate - slideWidth * focusAt - gap * focusAt;
    }
  };
}
/**
 * Applies diffrent transformers on translate value.
 *
 * @param  {Object} Glide
 * @param  {Object} Components
 * @return {Object}
 */


function mutator(Glide, Components, Events) {
  /**
   * Merge instance transformers with collection of default transformers.
   * It's important that the Rtl component be last on the list,
   * so it reflects all previous transformations.
   *
   * @type {Array}
   */
  var TRANSFORMERS = [Gap, Grow, Peeking, Focusing].concat(Glide._t, [Rtl]);
  return {
    /**
     * Piplines translate value with registered transformers.
     *
     * @param  {Number} translate
     * @return {Number}
     */
    mutate: function mutate(translate) {
      for (var i = 0; i < TRANSFORMERS.length; i++) {
        var transformer = TRANSFORMERS[i];

        if (isFunction(transformer) && isFunction(transformer().modify)) {
          translate = transformer(Glide, Components, Events).modify(translate);
        } else {
          warn('Transformer should be a function that returns an object with `modify()` method');
        }
      }

      return translate;
    }
  };
}

function Translate(Glide, Components, Events) {
  var Translate = {
    /**
     * Sets value of translate on HTML element.
     *
     * @param {Number} value
     * @return {Void}
     */
    set: function set(value) {
      var transform = mutator(Glide, Components).mutate(value);
      var translate3d = "translate3d(".concat(-1 * transform, "px, 0px, 0px)");
      Components.Html.wrapper.style.mozTransform = translate3d; // needed for supported Firefox 10-15

      Components.Html.wrapper.style.webkitTransform = translate3d; // needed for supported Chrome 10-35, Safari 5.1-8, and Opera 15-22

      Components.Html.wrapper.style.transform = translate3d;
    },

    /**
     * Removes value of translate from HTML element.
     *
     * @return {Void}
     */
    remove: function remove() {
      Components.Html.wrapper.style.transform = '';
    },

    /**
     * @return {number}
     */
    getStartIndex: function getStartIndex() {
      var length = Components.Sizes.length;
      var index = Glide.index;
      var perView = Glide.settings.perView;

      if (Components.Run.isOffset('>') || Components.Run.isOffset('|>')) {
        return length + (index - perView);
      } // "modulo length" converts an index that equals length to zero


      return (index + perView) % length;
    },

    /**
     * @return {number}
     */
    getTravelDistance: function getTravelDistance() {
      var travelDistance = Components.Sizes.slideWidth * Glide.settings.perView;

      if (Components.Run.isOffset('>') || Components.Run.isOffset('|>')) {
        // reverse travel distance so that we don't have to change subtract operations
        return travelDistance * -1;
      }

      return travelDistance;
    }
  };
  /**
   * Set new translate value:
   * - on move to reflect index change
   * - on updating via API to reflect possible changes in options
   */

  Events.on('move', function (context) {
    if (!Glide.isType('carousel') || !Components.Run.isOffset()) {
      return Translate.set(context.movement);
    }

    Components.Transition.after(function () {
      Events.emit('translate.jump');
      Translate.set(Components.Sizes.slideWidth * Glide.index);
    });
    var startWidth = Components.Sizes.slideWidth * Components.Translate.getStartIndex();
    return Translate.set(startWidth - Components.Translate.getTravelDistance());
  });
  /**
   * Remove translate:
   * - on destroying to bring markup to its inital state
   */

  Events.on('destroy', function () {
    Translate.remove();
  });
  return Translate;
}

function Transition(Glide, Components, Events) {
  /**
   * Holds inactivity status of transition.
   * When true transition is not applied.
   *
   * @type {Boolean}
   */
  var disabled = false;
  var Transition = {
    /**
     * Composes string of the CSS transition.
     *
     * @param {String} property
     * @return {String}
     */
    compose: function compose(property) {
      var settings = Glide.settings;

      if (disabled) {
        return "".concat(property, " 0ms ").concat(settings.animationTimingFunc);
      }

      return "".concat(property, " ").concat(this.duration, "ms ").concat(settings.animationTimingFunc);
    },

    /**
     * Sets value of transition on HTML element.
     *
     * @param {String=} property
     * @return {Void}
     */
    set: function set() {
      var property = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'transform';
      Components.Html.wrapper.style.transition = this.compose(property);
    },

    /**
     * Removes value of transition from HTML element.
     *
     * @return {Void}
     */
    remove: function remove() {
      Components.Html.wrapper.style.transition = '';
    },

    /**
     * Runs callback after animation.
     *
     * @param  {Function} callback
     * @return {Void}
     */
    after: function after(callback) {
      setTimeout(function () {
        callback();
      }, this.duration);
    },

    /**
     * Enable transition.
     *
     * @return {Void}
     */
    enable: function enable() {
      disabled = false;
      this.set();
    },

    /**
     * Disable transition.
     *
     * @return {Void}
     */
    disable: function disable() {
      disabled = true;
      this.set();
    }
  };
  define(Transition, 'duration', {
    /**
     * Gets duration of the transition based
     * on currently running animation type.
     *
     * @return {Number}
     */
    get: function get() {
      var settings = Glide.settings;

      if (Glide.isType('slider') && Components.Run.offset) {
        return settings.rewindDuration;
      }

      return settings.animationDuration;
    }
  });
  /**
   * Set transition `style` value:
   * - on each moving, because it may be cleared by offset move
   */

  Events.on('move', function () {
    Transition.set();
  });
  /**
   * Disable transition:
   * - before initial build to avoid transitioning from `0` to `startAt` index
   * - while resizing window and recalculating dimensions
   * - on jumping from offset transition at start and end edges in `carousel` type
   */

  Events.on(['build.before', 'resize', 'translate.jump'], function () {
    Transition.disable();
  });
  /**
   * Enable transition:
   * - on each running, because it may be disabled by offset move
   */

  Events.on('run', function () {
    Transition.enable();
  });
  /**
   * Remove transition:
   * - on destroying to bring markup to its inital state
   */

  Events.on('destroy', function () {
    Transition.remove();
  });
  return Transition;
}
/**
 * Test via a getter in the options object to see
 * if the passive property is accessed.
 *
 * @see https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md#feature-detection
 */


var supportsPassive = false;

try {
  var opts = Object.defineProperty({}, 'passive', {
    get: function get() {
      supportsPassive = true;
    }
  });
  window.addEventListener('testPassive', null, opts);
  window.removeEventListener('testPassive', null, opts);
} catch (e) {}

var supportsPassive$1 = supportsPassive;
var START_EVENTS = ['touchstart', 'mousedown'];
var MOVE_EVENTS = ['touchmove', 'mousemove'];
var END_EVENTS = ['touchend', 'touchcancel', 'mouseup', 'mouseleave'];
var MOUSE_EVENTS = ['mousedown', 'mousemove', 'mouseup', 'mouseleave'];

function Swipe(Glide, Components, Events) {
  /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */
  var Binder = new EventsBinder();
  var swipeSin = 0;
  var swipeStartX = 0;
  var swipeStartY = 0;
  var disabled = false;
  var capture = supportsPassive$1 ? {
    passive: true
  } : false;
  var Swipe = {
    /**
     * Initializes swipe bindings.
     *
     * @return {Void}
     */
    mount: function mount() {
      this.bindSwipeStart();
    },

    /**
     * Handler for `swipestart` event. Calculates entry points of the user's tap.
     *
     * @param {Object} event
     * @return {Void}
     */
    start: function start(event) {
      if (!disabled && !Glide.disabled) {
        this.disable();
        var swipe = this.touches(event);
        swipeSin = null;
        swipeStartX = toInt(swipe.pageX);
        swipeStartY = toInt(swipe.pageY);
        this.bindSwipeMove();
        this.bindSwipeEnd();
        Events.emit('swipe.start');
      }
    },

    /**
     * Handler for `swipemove` event. Calculates user's tap angle and distance.
     *
     * @param {Object} event
     */
    move: function move(event) {
      if (!Glide.disabled) {
        var _Glide$settings = Glide.settings,
            touchAngle = _Glide$settings.touchAngle,
            touchRatio = _Glide$settings.touchRatio,
            classes = _Glide$settings.classes;
        var swipe = this.touches(event);
        var subExSx = toInt(swipe.pageX) - swipeStartX;
        var subEySy = toInt(swipe.pageY) - swipeStartY;
        var powEX = Math.abs(subExSx << 2);
        var powEY = Math.abs(subEySy << 2);
        var swipeHypotenuse = Math.sqrt(powEX + powEY);
        var swipeCathetus = Math.sqrt(powEY);
        swipeSin = Math.asin(swipeCathetus / swipeHypotenuse);

        if (swipeSin * 180 / Math.PI < touchAngle) {
          event.stopPropagation();
          Components.Move.make(subExSx * toFloat(touchRatio));
          Components.Html.root.classList.add(classes.dragging);
          Events.emit('swipe.move');
        } else {
          return false;
        }
      }
    },

    /**
     * Handler for `swipeend` event. Finitializes user's tap and decides about glide move.
     *
     * @param {Object} event
     * @return {Void}
     */
    end: function end(event) {
      if (!Glide.disabled) {
        var _Glide$settings2 = Glide.settings,
            perSwipe = _Glide$settings2.perSwipe,
            touchAngle = _Glide$settings2.touchAngle,
            classes = _Glide$settings2.classes;
        var swipe = this.touches(event);
        var threshold = this.threshold(event);
        var swipeDistance = swipe.pageX - swipeStartX;
        var swipeDeg = swipeSin * 180 / Math.PI;
        this.enable();

        if (swipeDistance > threshold && swipeDeg < touchAngle) {
          Components.Run.make(Components.Direction.resolve("".concat(perSwipe, "<")));
        } else if (swipeDistance < -threshold && swipeDeg < touchAngle) {
          Components.Run.make(Components.Direction.resolve("".concat(perSwipe, ">")));
        } else {
          // While swipe don't reach distance apply previous transform.
          Components.Move.make();
        }

        Components.Html.root.classList.remove(classes.dragging);
        this.unbindSwipeMove();
        this.unbindSwipeEnd();
        Events.emit('swipe.end');
      }
    },

    /**
     * Binds swipe's starting event.
     *
     * @return {Void}
     */
    bindSwipeStart: function bindSwipeStart() {
      var _this = this;

      var _Glide$settings3 = Glide.settings,
          swipeThreshold = _Glide$settings3.swipeThreshold,
          dragThreshold = _Glide$settings3.dragThreshold;

      if (swipeThreshold) {
        Binder.on(START_EVENTS[0], Components.Html.wrapper, function (event) {
          _this.start(event);
        }, capture);
      }

      if (dragThreshold) {
        Binder.on(START_EVENTS[1], Components.Html.wrapper, function (event) {
          _this.start(event);
        }, capture);
      }
    },

    /**
     * Unbinds swipe's starting event.
     *
     * @return {Void}
     */
    unbindSwipeStart: function unbindSwipeStart() {
      Binder.off(START_EVENTS[0], Components.Html.wrapper, capture);
      Binder.off(START_EVENTS[1], Components.Html.wrapper, capture);
    },

    /**
     * Binds swipe's moving event.
     *
     * @return {Void}
     */
    bindSwipeMove: function bindSwipeMove() {
      var _this2 = this;

      Binder.on(MOVE_EVENTS, Components.Html.wrapper, throttle(function (event) {
        _this2.move(event);
      }, Glide.settings.throttle), capture);
    },

    /**
     * Unbinds swipe's moving event.
     *
     * @return {Void}
     */
    unbindSwipeMove: function unbindSwipeMove() {
      Binder.off(MOVE_EVENTS, Components.Html.wrapper, capture);
    },

    /**
     * Binds swipe's ending event.
     *
     * @return {Void}
     */
    bindSwipeEnd: function bindSwipeEnd() {
      var _this3 = this;

      Binder.on(END_EVENTS, Components.Html.wrapper, function (event) {
        _this3.end(event);
      });
    },

    /**
     * Unbinds swipe's ending event.
     *
     * @return {Void}
     */
    unbindSwipeEnd: function unbindSwipeEnd() {
      Binder.off(END_EVENTS, Components.Html.wrapper);
    },

    /**
     * Normalizes event touches points accorting to different types.
     *
     * @param {Object} event
     */
    touches: function touches(event) {
      if (MOUSE_EVENTS.indexOf(event.type) > -1) {
        return event;
      }

      return event.touches[0] || event.changedTouches[0];
    },

    /**
     * Gets value of minimum swipe distance settings based on event type.
     *
     * @return {Number}
     */
    threshold: function threshold(event) {
      var settings = Glide.settings;

      if (MOUSE_EVENTS.indexOf(event.type) > -1) {
        return settings.dragThreshold;
      }

      return settings.swipeThreshold;
    },

    /**
     * Enables swipe event.
     *
     * @return {self}
     */
    enable: function enable() {
      disabled = false;
      Components.Transition.enable();
      return this;
    },

    /**
     * Disables swipe event.
     *
     * @return {self}
     */
    disable: function disable() {
      disabled = true;
      Components.Transition.disable();
      return this;
    }
  };
  /**
   * Add component class:
   * - after initial building
   */

  Events.on('build.after', function () {
    Components.Html.root.classList.add(Glide.settings.classes.swipeable);
  });
  /**
   * Remove swiping bindings:
   * - on destroying, to remove added EventListeners
   */

  Events.on('destroy', function () {
    Swipe.unbindSwipeStart();
    Swipe.unbindSwipeMove();
    Swipe.unbindSwipeEnd();
    Binder.destroy();
  });
  return Swipe;
}

function Images(Glide, Components, Events) {
  /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */
  var Binder = new EventsBinder();
  var Images = {
    /**
     * Binds listener to glide wrapper.
     *
     * @return {Void}
     */
    mount: function mount() {
      this.bind();
    },

    /**
     * Binds `dragstart` event on wrapper to prevent dragging images.
     *
     * @return {Void}
     */
    bind: function bind() {
      Binder.on('dragstart', Components.Html.wrapper, this.dragstart);
    },

    /**
     * Unbinds `dragstart` event on wrapper.
     *
     * @return {Void}
     */
    unbind: function unbind() {
      Binder.off('dragstart', Components.Html.wrapper);
    },

    /**
     * Event handler. Prevents dragging.
     *
     * @return {Void}
     */
    dragstart: function dragstart(event) {
      event.preventDefault();
    }
  };
  /**
   * Remove bindings from images:
   * - on destroying, to remove added EventListeners
   */

  Events.on('destroy', function () {
    Images.unbind();
    Binder.destroy();
  });
  return Images;
}

function Anchors(Glide, Components, Events) {
  /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */
  var Binder = new EventsBinder();
  /**
   * Holds detaching status of anchors.
   * Prevents detaching of already detached anchors.
   *
   * @private
   * @type {Boolean}
   */

  var detached = false;
  /**
   * Holds preventing status of anchors.
   * If `true` redirection after click will be disabled.
   *
   * @private
   * @type {Boolean}
   */

  var prevented = false;
  var Anchors = {
    /**
     * Setups a initial state of anchors component.
     *
     * @returns {Void}
     */
    mount: function mount() {
      /**
       * Holds collection of anchors elements.
       *
       * @private
       * @type {HTMLCollection}
       */
      this._a = Components.Html.wrapper.querySelectorAll('a');
      this.bind();
    },

    /**
     * Binds events to anchors inside a track.
     *
     * @return {Void}
     */
    bind: function bind() {
      Binder.on('click', Components.Html.wrapper, this.click);
    },

    /**
     * Unbinds events attached to anchors inside a track.
     *
     * @return {Void}
     */
    unbind: function unbind() {
      Binder.off('click', Components.Html.wrapper);
    },

    /**
     * Handler for click event. Prevents clicks when glide is in `prevent` status.
     *
     * @param  {Object} event
     * @return {Void}
     */
    click: function click(event) {
      if (prevented) {
        event.stopPropagation();
        event.preventDefault();
      }
    },

    /**
     * Detaches anchors click event inside glide.
     *
     * @return {self}
     */
    detach: function detach() {
      prevented = true;

      if (!detached) {
        for (var i = 0; i < this.items.length; i++) {
          this.items[i].draggable = false;
        }

        detached = true;
      }

      return this;
    },

    /**
     * Attaches anchors click events inside glide.
     *
     * @return {self}
     */
    attach: function attach() {
      prevented = false;

      if (detached) {
        for (var i = 0; i < this.items.length; i++) {
          this.items[i].draggable = true;
        }

        detached = false;
      }

      return this;
    }
  };
  define(Anchors, 'items', {
    /**
     * Gets collection of the arrows HTML elements.
     *
     * @return {HTMLElement[]}
     */
    get: function get() {
      return Anchors._a;
    }
  });
  /**
   * Detach anchors inside slides:
   * - on swiping, so they won't redirect to its `href` attributes
   */

  Events.on('swipe.move', function () {
    Anchors.detach();
  });
  /**
   * Attach anchors inside slides:
   * - after swiping and transitions ends, so they can redirect after click again
   */

  Events.on('swipe.end', function () {
    Components.Transition.after(function () {
      Anchors.attach();
    });
  });
  /**
   * Unbind anchors inside slides:
   * - on destroying, to bring anchors to its initial state
   */

  Events.on('destroy', function () {
    Anchors.attach();
    Anchors.unbind();
    Binder.destroy();
  });
  return Anchors;
}

var NAV_SELECTOR = '[data-glide-el="controls[nav]"]';
var CONTROLS_SELECTOR = '[data-glide-el^="controls"]';
var PREVIOUS_CONTROLS_SELECTOR = "".concat(CONTROLS_SELECTOR, " [data-glide-dir*=\"<\"]");
var NEXT_CONTROLS_SELECTOR = "".concat(CONTROLS_SELECTOR, " [data-glide-dir*=\">\"]");

function Controls(Glide, Components, Events) {
  /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */
  var Binder = new EventsBinder();
  var capture = supportsPassive$1 ? {
    passive: true
  } : false;
  var Controls = {
    /**
     * Inits arrows. Binds events listeners
     * to the arrows HTML elements.
     *
     * @return {Void}
     */
    mount: function mount() {
      /**
       * Collection of navigation HTML elements.
       *
       * @private
       * @type {HTMLCollection}
       */
      this._n = Components.Html.root.querySelectorAll(NAV_SELECTOR);
      /**
       * Collection of controls HTML elements.
       *
       * @private
       * @type {HTMLCollection}
       */

      this._c = Components.Html.root.querySelectorAll(CONTROLS_SELECTOR);
      /**
       * Collection of arrow control HTML elements.
       *
       * @private
       * @type {Object}
       */

      this._arrowControls = {
        previous: Components.Html.root.querySelectorAll(PREVIOUS_CONTROLS_SELECTOR),
        next: Components.Html.root.querySelectorAll(NEXT_CONTROLS_SELECTOR)
      };
      this.addBindings();
    },

    /**
     * Sets active class to current slide.
     *
     * @return {Void}
     */
    setActive: function setActive() {
      for (var i = 0; i < this._n.length; i++) {
        this.addClass(this._n[i].children);
      }
    },

    /**
     * Removes active class to current slide.
     *
     * @return {Void}
     */
    removeActive: function removeActive() {
      for (var i = 0; i < this._n.length; i++) {
        this.removeClass(this._n[i].children);
      }
    },

    /**
     * Toggles active class on items inside navigation.
     *
     * @param  {HTMLElement} controls
     * @return {Void}
     */
    addClass: function addClass(controls) {
      var settings = Glide.settings;
      var item = controls[Glide.index];

      if (!item) {
        return;
      }

      item.classList.add(settings.classes.nav.active);
      siblings(item).forEach(function (sibling) {
        sibling.classList.remove(settings.classes.nav.active);
      });
    },

    /**
     * Removes active class from active control.
     *
     * @param  {HTMLElement} controls
     * @return {Void}
     */
    removeClass: function removeClass(controls) {
      var item = controls[Glide.index];
      item === null || item === void 0 ? void 0 : item.classList.remove(Glide.settings.classes.nav.active);
    },

    /**
     * Calculates, removes or adds `Glide.settings.classes.disabledArrow` class on the control arrows
     */
    setArrowState: function setArrowState() {
      if (Glide.settings.rewind) {
        return;
      }

      var next = Controls._arrowControls.next;
      var previous = Controls._arrowControls.previous;
      this.resetArrowState(next, previous);

      if (Glide.index === 0) {
        this.disableArrow(previous);
      }

      if (Glide.index === Components.Run.length) {
        this.disableArrow(next);
      }
    },

    /**
     * Removes `Glide.settings.classes.disabledArrow` from given NodeList elements
     *
     * @param {NodeList[]} lists
     */
    resetArrowState: function resetArrowState() {
      var settings = Glide.settings;

      for (var _len = arguments.length, lists = new Array(_len), _key = 0; _key < _len; _key++) {
        lists[_key] = arguments[_key];
      }

      lists.forEach(function (list) {
        toArray(list).forEach(function (element) {
          element.classList.remove(settings.classes.arrow.disabled);
        });
      });
    },

    /**
     * Adds `Glide.settings.classes.disabledArrow` to given NodeList elements
     *
     * @param {NodeList[]} lists
     */
    disableArrow: function disableArrow() {
      var settings = Glide.settings;

      for (var _len2 = arguments.length, lists = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        lists[_key2] = arguments[_key2];
      }

      lists.forEach(function (list) {
        toArray(list).forEach(function (element) {
          element.classList.add(settings.classes.arrow.disabled);
        });
      });
    },

    /**
     * Adds handles to the each group of controls.
     *
     * @return {Void}
     */
    addBindings: function addBindings() {
      for (var i = 0; i < this._c.length; i++) {
        this.bind(this._c[i].children);
      }
    },

    /**
     * Removes handles from the each group of controls.
     *
     * @return {Void}
     */
    removeBindings: function removeBindings() {
      for (var i = 0; i < this._c.length; i++) {
        this.unbind(this._c[i].children);
      }
    },

    /**
     * Binds events to arrows HTML elements.
     *
     * @param {HTMLCollection} elements
     * @return {Void}
     */
    bind: function bind(elements) {
      for (var i = 0; i < elements.length; i++) {
        Binder.on('click', elements[i], this.click);
        Binder.on('touchstart', elements[i], this.click, capture);
      }
    },

    /**
     * Unbinds events binded to the arrows HTML elements.
     *
     * @param {HTMLCollection} elements
     * @return {Void}
     */
    unbind: function unbind(elements) {
      for (var i = 0; i < elements.length; i++) {
        Binder.off(['click', 'touchstart'], elements[i]);
      }
    },

    /**
     * Handles `click` event on the arrows HTML elements.
     * Moves slider in direction given via the
     * `data-glide-dir` attribute.
     *
     * @param {Object} event
     * @return {void}
     */
    click: function click(event) {
      if (!supportsPassive$1 && event.type === 'touchstart') {
        event.preventDefault();
      }

      var direction = event.currentTarget.getAttribute('data-glide-dir');
      Components.Run.make(Components.Direction.resolve(direction));
    }
  };
  define(Controls, 'items', {
    /**
     * Gets collection of the controls HTML elements.
     *
     * @return {HTMLElement[]}
     */
    get: function get() {
      return Controls._c;
    }
  });
  /**
   * Swap active class of current navigation item:
   * - after mounting to set it to initial index
   * - after each move to the new index
   */

  Events.on(['mount.after', 'move.after'], function () {
    Controls.setActive();
  });
  /**
   * Add or remove disabled class of arrow elements
   */

  Events.on(['mount.after', 'run'], function () {
    Controls.setArrowState();
  });
  /**
   * Remove bindings and HTML Classes:
   * - on destroying, to bring markup to its initial state
   */

  Events.on('destroy', function () {
    Controls.removeBindings();
    Controls.removeActive();
    Binder.destroy();
  });
  return Controls;
}

function Keyboard(Glide, Components, Events) {
  /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */
  var Binder = new EventsBinder();
  var Keyboard = {
    /**
     * Binds keyboard events on component mount.
     *
     * @return {Void}
     */
    mount: function mount() {
      if (Glide.settings.keyboard) {
        this.bind();
      }
    },

    /**
     * Adds keyboard press events.
     *
     * @return {Void}
     */
    bind: function bind() {
      Binder.on('keyup', document, this.press);
    },

    /**
     * Removes keyboard press events.
     *
     * @return {Void}
     */
    unbind: function unbind() {
      Binder.off('keyup', document);
    },

    /**
     * Handles keyboard's arrows press and moving glide foward and backward.
     *
     * @param  {Object} event
     * @return {Void}
     */
    press: function press(event) {
      var perSwipe = Glide.settings.perSwipe;
      var arrowSymbols = {
        ArrowRight: '>',
        ArrowLeft: '<'
      };

      if (['ArrowRight', 'ArrowLeft'].includes(event.code)) {
        Components.Run.make(Components.Direction.resolve("".concat(perSwipe).concat(arrowSymbols[event.code])));
      }
    }
  };
  /**
   * Remove bindings from keyboard:
   * - on destroying to remove added events
   * - on updating to remove events before remounting
   */

  Events.on(['destroy', 'update'], function () {
    Keyboard.unbind();
  });
  /**
   * Remount component
   * - on updating to reflect potential changes in settings
   */

  Events.on('update', function () {
    Keyboard.mount();
  });
  /**
   * Destroy binder:
   * - on destroying to remove listeners
   */

  Events.on('destroy', function () {
    Binder.destroy();
  });
  return Keyboard;
}

function Autoplay(Glide, Components, Events) {
  /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */
  var Binder = new EventsBinder();
  var Autoplay = {
    /**
     * Initializes autoplaying and events.
     *
     * @return {Void}
     */
    mount: function mount() {
      this.enable();
      this.start();

      if (Glide.settings.hoverpause) {
        this.bind();
      }
    },

    /**
     * Enables autoplaying
     *
     * @returns {Void}
     */
    enable: function enable() {
      this._e = true;
    },

    /**
     * Disables autoplaying.
     *
     * @returns {Void}
     */
    disable: function disable() {
      this._e = false;
    },

    /**
     * Starts autoplaying in configured interval.
     *
     * @param {Boolean|Number} force Run autoplaying with passed interval regardless of `autoplay` settings
     * @return {Void}
     */
    start: function start() {
      var _this = this;

      if (!this._e) {
        return;
      }

      this.enable();

      if (Glide.settings.autoplay) {
        if (isUndefined(this._i)) {
          this._i = setInterval(function () {
            _this.stop();

            Components.Run.make('>');

            _this.start();

            Events.emit('autoplay');
          }, this.time);
        }
      }
    },

    /**
     * Stops autorunning of the glide.
     *
     * @return {Void}
     */
    stop: function stop() {
      this._i = clearInterval(this._i);
    },

    /**
     * Stops autoplaying while mouse is over glide's area.
     *
     * @return {Void}
     */
    bind: function bind() {
      var _this2 = this;

      Binder.on('mouseover', Components.Html.root, function () {
        if (_this2._e) {
          _this2.stop();
        }
      });
      Binder.on('mouseout', Components.Html.root, function () {
        if (_this2._e) {
          _this2.start();
        }
      });
    },

    /**
     * Unbind mouseover events.
     *
     * @returns {Void}
     */
    unbind: function unbind() {
      Binder.off(['mouseover', 'mouseout'], Components.Html.root);
    }
  };
  define(Autoplay, 'time', {
    /**
     * Gets time period value for the autoplay interval. Prioritizes
     * times in `data-glide-autoplay` attrubutes over options.
     *
     * @return {Number}
     */
    get: function get() {
      var autoplay = Components.Html.slides[Glide.index].getAttribute('data-glide-autoplay');

      if (autoplay) {
        return toInt(autoplay);
      }

      return toInt(Glide.settings.autoplay);
    }
  });
  /**
   * Stop autoplaying and unbind events:
   * - on destroying, to clear defined interval
   * - on updating via API to reset interval that may changed
   */

  Events.on(['destroy', 'update'], function () {
    Autoplay.unbind();
  });
  /**
   * Stop autoplaying:
   * - before each run, to restart autoplaying
   * - on pausing via API
   * - on destroying, to clear defined interval
   * - while starting a swipe
   * - on updating via API to reset interval that may changed
   */

  Events.on(['run.before', 'swipe.start', 'update'], function () {
    Autoplay.stop();
  });
  Events.on(['pause', 'destroy'], function () {
    Autoplay.disable();
    Autoplay.stop();
  });
  /**
   * Start autoplaying:
   * - after each run, to restart autoplaying
   * - on playing via API
   * - while ending a swipe
   */

  Events.on(['run.after', 'swipe.end'], function () {
    Autoplay.start();
  });
  /**
   * Start autoplaying:
   * - after each run, to restart autoplaying
   * - on playing via API
   * - while ending a swipe
   */

  Events.on(['play'], function () {
    Autoplay.enable();
    Autoplay.start();
  });
  /**
   * Remount autoplaying:
   * - on updating via API to reset interval that may changed
   */

  Events.on('update', function () {
    Autoplay.mount();
  });
  /**
   * Destroy a binder:
   * - on destroying glide instance to clearup listeners
   */

  Events.on('destroy', function () {
    Binder.destroy();
  });
  return Autoplay;
}
/**
 * Sorts keys of breakpoint object so they will be ordered from lower to bigger.
 *
 * @param {Object} points
 * @returns {Object}
 */


function sortBreakpoints(points) {
  if (isObject(points)) {
    return sortKeys(points);
  } else {
    warn("Breakpoints option must be an object");
  }

  return {};
}

function Breakpoints(Glide, Components, Events) {
  /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */
  var Binder = new EventsBinder();
  /**
   * Holds reference to settings.
   *
   * @type {Object}
   */

  var settings = Glide.settings;
  /**
   * Holds reference to breakpoints object in settings. Sorts breakpoints
   * from smaller to larger. It is required in order to proper
   * matching currently active breakpoint settings.
   *
   * @type {Object}
   */

  var points = sortBreakpoints(settings.breakpoints);
  /**
   * Cache initial settings before overwritting.
   *
   * @type {Object}
   */

  var defaults = Object.assign({}, settings);
  var Breakpoints = {
    /**
     * Matches settings for currectly matching media breakpoint.
     *
     * @param {Object} points
     * @returns {Object}
     */
    match: function match(points) {
      if (typeof window.matchMedia !== 'undefined') {
        for (var point in points) {
          if (points.hasOwnProperty(point)) {
            if (window.matchMedia("(max-width: ".concat(point, "px)")).matches) {
              return points[point];
            }
          }
        }
      }

      return defaults;
    }
  };
  /**
   * Overwrite instance settings with currently matching breakpoint settings.
   * This happens right after component initialization.
   */

  Object.assign(settings, Breakpoints.match(points));
  /**
   * Update glide with settings of matched brekpoint:
   * - window resize to update slider
   */

  Binder.on('resize', window, throttle(function () {
    Glide.settings = mergeOptions(settings, Breakpoints.match(points));
  }, Glide.settings.throttle));
  /**
   * Resort and update default settings:
   * - on reinit via API, so breakpoint matching will be performed with options
   */

  Events.on('update', function () {
    points = sortBreakpoints(points);
    defaults = Object.assign({}, settings);
  });
  /**
   * Unbind resize listener:
   * - on destroying, to bring markup to its initial state
   */

  Events.on('destroy', function () {
    Binder.off('resize', window);
  });
  return Breakpoints;
}

var COMPONENTS = {
  // Required
  Html: Html,
  Translate: Translate,
  Transition: Transition,
  Direction: Direction,
  Peek: Peek,
  Sizes: Sizes,
  Gaps: Gaps,
  Move: Move,
  Clones: Clones,
  Resize: Resize,
  Build: Build,
  Run: Run,
  // Optional
  Swipe: Swipe,
  Images: Images,
  Anchors: Anchors,
  Controls: Controls,
  Keyboard: Keyboard,
  Autoplay: Autoplay,
  Breakpoints: Breakpoints
};

var Glide = /*#__PURE__*/function (_Core) {
  _inherits(Glide, _Core);

  var _super = _createSuper(Glide);

  function Glide() {
    _classCallCheck(this, Glide);

    return _super.apply(this, arguments);
  }

  _createClass(Glide, [{
    key: "mount",
    value: function mount() {
      var extensions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return _get(_getPrototypeOf(Glide.prototype), "mount", this).call(this, Object.assign({}, COMPONENTS, extensions));
    }
  }]);

  return Glide;
}(Glide$1);



/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			loaded: false,
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/node module decorator */
/******/ 	(() => {
/******/ 		__webpack_require__.nmd = (module) => {
/******/ 			module.paths = [];
/******/ 			if (!module.children) module.children = [];
/******/ 			return module;
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
var __webpack_exports__ = {};
/*!**************************!*\
  !*** ./src/js/custom.js ***!
  \**************************/
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _modules_ed_video_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./modules/ed-video-component */ "./src/js/modules/ed-video-component.js");
/* harmony import */ var _modules_ed_video_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_video_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _modules_ed_featured_product__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./modules/ed-featured-product */ "./src/js/modules/ed-featured-product.js");
/* harmony import */ var _modules_ed_featured_product__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_featured_product__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _modules_ed_cart_upsell__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./modules/ed-cart-upsell */ "./src/js/modules/ed-cart-upsell.js");
/* harmony import */ var _modules_ed_cart_upsell__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_cart_upsell__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _modules_ed_known_for__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./modules/ed-known-for */ "./src/js/modules/ed-known-for.js");
/* harmony import */ var _modules_ed_product_suggestion__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./modules/ed-product-suggestion */ "./src/js/modules/ed-product-suggestion.js");
/* harmony import */ var _modules_ed_product_suggestion__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_product_suggestion__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _modules_ed_auto_discount_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./modules/ed-auto-discount.js */ "./src/js/modules/ed-auto-discount.js");
/* harmony import */ var _modules_ed_auto_discount_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_auto_discount_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _modules_ed_bundles_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./modules/ed-bundles.js */ "./src/js/modules/ed-bundles.js");
/* harmony import */ var _modules_ed_bundles_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_bundles_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _modules_ed_product_upsell_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./modules/ed-product-upsell.js */ "./src/js/modules/ed-product-upsell.js");
/* harmony import */ var _modules_ed_product_upsell_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_product_upsell_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _modules_ed_more_info_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./modules/ed-more-info.js */ "./src/js/modules/ed-more-info.js");
/* harmony import */ var _modules_ed_more_info_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_more_info_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _modules_ed_cart_qty_ajax_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./modules/ed-cart-qty-ajax.js */ "./src/js/modules/ed-cart-qty-ajax.js");
/* harmony import */ var _modules_ed_cart_qty_ajax_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_cart_qty_ajax_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _modules_ed_cart_refresh_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./modules/ed-cart-refresh.js */ "./src/js/modules/ed-cart-refresh.js");
/* harmony import */ var _modules_ed_cart_refresh_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_cart_refresh_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _modules_ed_recharge_subscription_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./modules/ed-recharge-subscription.js */ "./src/js/modules/ed-recharge-subscription.js");
/* harmony import */ var _modules_ed_recharge_subscription_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_recharge_subscription_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _modules_ed_mobile_pdp_gallery_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./modules/ed-mobile-pdp-gallery.js */ "./src/js/modules/ed-mobile-pdp-gallery.js");
/* harmony import */ var _modules_ed_mobile_pdp_gallery_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_mobile_pdp_gallery_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _modules_blog_filter_bar_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./modules/blog-filter-bar.js */ "./src/js/modules/blog-filter-bar.js");
/* harmony import */ var _modules_blog_filter_bar_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_modules_blog_filter_bar_js__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _modules_ed_review_photos_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./modules/ed-review-photos.js */ "./src/js/modules/ed-review-photos.js");
/* harmony import */ var _modules_ed_review_photos_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_review_photos_js__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _modules_ed_variant_delivery_label_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./modules/ed-variant-delivery-label.js */ "./src/js/modules/ed-variant-delivery-label.js");
/* harmony import */ var _modules_ed_variant_delivery_label_js__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_variant_delivery_label_js__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _modules_ed_upsell_popup_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./modules/ed-upsell-popup.js */ "./src/js/modules/ed-upsell-popup.js");
/* harmony import */ var _modules_ed_upsell_popup_js__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_upsell_popup_js__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _modules_ed_warranty_modal_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./modules/ed-warranty-modal.js */ "./src/js/modules/ed-warranty-modal.js");
/* harmony import */ var _modules_ed_warranty_modal_js__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_warranty_modal_js__WEBPACK_IMPORTED_MODULE_18__);
/*
DO NOT TOUCH THIS FILE OUTSIDE OF /src DIRECTORY
this file gets compiled ./assets/custom.js - make sure to import every module here.
*/
// Babel compiles async/await to regenerator code; without this import the
// bundle depends on a third-party app defining window.regeneratorRuntime.



















})();

// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
/*!******************************!*\
  !*** ./src/scss/custom.scss ***!
  \******************************/
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin

})();

/******/ })()
;